webpackJsonp([5,23],{

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(716),
  /* template */
  __webpack_require__(718),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(782)
}
var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(735),
  /* template */
  __webpack_require__(796),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 716:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_handy__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_handy__);
//
//
//
//
//
//
//
//



var JsPDF = __webpack_require__(352);
__webpack_require__(717);

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['headers', 'items', 'title', 'subtitle', 'tablefooter', 'letterHead', 'landscape', 'fontsize', 'cellpadding', 'legend'],
  methods: {
    download: function download(type) {
      var _this = this;

      /* NOTE:
      Making use of PDF plug-in to generate CSV file as well
      */
      // construnct cols from passed table heading
      var cols = [];
      var colStyle = {};
      var colFormat = [];
      this.headers.forEach(function (rec) {
        if (rec.text) {
          // column title and value key
          cols.push({ title: rec.text, dataKey: rec.value });
          // column style if any
          if (rec.align || rec.columnWidth) {
            colStyle[rec.value] = {};
            if (rec.align) {
              colStyle[rec.value].halign = rec.align;
            }
            if (rec.columnWidth) {
              colStyle[rec.value].columnWidth = rec.columnWidth;
            }
          }
          // column format if any
          colFormat[rec.value] = rec.format;
        }
      });
      // local copy for later use
      var locItems = this.items;

      // pdf
      var doc = null;
      if (this.landscape) {
        doc = new JsPDF('landscape');
      } else {
        doc = new JsPDF();
      }

      var totalPagesExp = '{total_pages_count_string}';
      var pageContent = function pageContent(data) {
        // HEADER
        doc.setFontSize(20);
        doc.setFontStyle('normal');
        // a. community details
        if (!_this.letterHead) {
          doc.setTextColor(139, 195, 74);
          doc.text(__WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.COMM_NAME, data.settings.margin.left, 15);
          doc.setDrawColor(241, 241, 241);
          doc.line(0, 20, doc.internal.pageSize.width || doc.internal.pageSize.getWidth(), 20);
        }
        doc.setTextColor(40);

        // b. report heading
        doc.setFontSize(16);
        doc.text(_this.title, data.settings.margin.left, 30);
        // c. report subheading
        if (_this.subtitle) {
          doc.setFontSize(10);
          doc.text(_this.subtitle, data.settings.margin.left, 35);
        }

        // FOOTER
        var str = 'Page ' + data.pageCount;
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' of ' + totalPagesExp;
        }
        doc.setFontSize(10);
        var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
        doc.text(str + '\nDownloaded By ' + __WEBPACK_IMPORTED_MODULE_0__config_app_cfg___default.a.CUST_NAME + ' On ' + __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDate(new Date()) + ' ' + __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.getTime12Hrs(new Date()), data.settings.margin.left, pageHeight - 10);
      };

      // FULL CONTENT
      var csvHeader = '';
      var csvCont = [];
      var csvLine = [];
      doc.autoTable(cols, this.items, {
        theme: 'grid',
        addPageContent: pageContent,
        margin: { top: this.subtitle ? 40 : 35 },
        columnStyles: colStyle,
        styles: {
          fontSize: this.fontsize || 10,
          cellPadding: this.cellpadding || 2,
          overflow: 'linebreak'
        },
        createdCell: function createdCell(cell, data) {
          if (cell.raw === null) {
            // special handling for nulls
            cell.text[0] = '';
            cell.raw = '';
          } else if (colFormat[data.column.dataKey]) {
            // formatting
            // format as requested
            cell.text[0] = __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a[colFormat[data.column.dataKey]](cell.raw);
          } else if (data.column.dataKey.indexOf('_list') < 0 && (data.column.dataKey.indexOf('_dt') >= 0 || data.column.dataKey.indexOf('_date') >= 0 || data.column.dataKey.indexOf('_on') >= 0)) {
            // special handling for dates
            cell.text[0] = __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDate(cell.raw);
          } else if (data.column.dataKey.indexOf('_time') >= 0 || data.column.dataKey.indexOf('_in') >= 0 || data.column.dataKey.indexOf('_out') >= 0) {
            // special handling for date time
            cell.text[0] = __WEBPACK_IMPORTED_MODULE_1__utils_handy___default.a.formatDisplayDateTime(cell.raw);
          } else if (data.column.raw.title.indexOf('?') >= 0) {
            // special handling boolean
            if (cell.raw === 0 || cell.raw === 1 || typeof cell.raw === 'boolean') {
              cell.text[0] = !cell.raw ? 'No' : 'Yes';
            }
          }
        },
        drawRow: function drawRow(row, data) {
          // used for CSV & to highlight footer
          csvLine = [];
          for (var col in row.cells) {
            if (row.cells[col].text.length) {
              csvLine.push('"' + (row.cells[col].raw && row.cells[col].raw.length > 1 ? row.cells[col].raw : row.cells[col].text) + '"');
            }
            if (locItems[row.index].styles) {
              // highlight / style row if required
              for (var atr in locItems[row.index].styles) {
                row.cells[col].styles[atr] = locItems[row.index].styles[atr];
              }
            }
          }
          if (!csvCont[row.index] && csvLine.length) {
            csvCont[row.index] = csvLine.join();
          }
        }
      });

      // table legend
      if (this.legend) {
        doc.setFontSize(8);
        doc.text(this.legend, 15, doc.autoTable.previous.finalY + 4);
      }

      // table footer
      if (this.tablefooter) {
        doc.setFontSize(12);
        doc.text(this.tablefooter, 15, doc.autoTable.previous.finalY + 10);
      }

      // page footer
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp);
      }

      // download
      if (type === 'PDF') {
        doc.save(this.title + '.pdf');
      } else {
        // csv
        csvHeader = cols.map(function (rec) {
          return rec.title;
        }).join() + '\n';
        csvCont = csvHeader + csvCont.filter(function (rec) {
          return rec;
        }).join('\n');
        // table footer if requested
        if (this.tablefooter) {
          csvCont += '\n' + this.tablefooter;
        }

        var blob = new Blob([csvCont]);
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob, { type: 'text/plain' });
        link.setAttribute('download', this.title + (this.subtitle ? ' ' + this.subtitle : '') + '.csv');
        document.body.appendChild(link); // Required for FF
        link.click();
        document.body.removeChild(link);
      }
    }
  }
});

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * jsPDF AutoTable plugin v2.3.5
 * Copyright (c) 2014 Simon Bengtsson, https://github.com/simonbengtsson/jsPDF-AutoTable 
 * 
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * 
 * * /if (typeof window === 'object') window.jspdfAutoTableVersion = '2.3.5';/*
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(352));
	else if(typeof define === 'function' && define.amd)
		define(["jspdf"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("jspdf")) : factory(root["jsPDF"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__18__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 17);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
/**
 * Ratio between font size and font height. The number comes from jspdf's source code
 */
exports.FONT_ROW_RATIO = 1.15;
var models_1 = __webpack_require__(4);
var table = null;
var assign = __webpack_require__(5);
var entries = __webpack_require__(19);
/**
 * Styles for the themes (overriding the default styles)
 */
exports.getTheme = function (name) {
    var themes = {
        'striped': {
            table: { fillColor: 255, textColor: 80, fontStyle: 'normal' },
            header: { textColor: 255, fillColor: [41, 128, 185], fontStyle: 'bold' },
            body: {},
            alternateRow: { fillColor: 245 }
        },
        'grid': {
            table: { fillColor: 255, textColor: 80, fontStyle: 'normal', lineWidth: 0.1 },
            header: { textColor: 255, fillColor: [26, 188, 156], fontStyle: 'bold', lineWidth: 0 },
            body: {},
            alternateRow: {}
        },
        'plain': {
            header: { fontStyle: 'bold' }
        }
    };
    return themes[name];
};
function getDefaults() {
    var scaleFactor = Config.scaleFactor();
    return {
        // Styling
        theme: 'striped',
        styles: {},
        headerStyles: {},
        bodyStyles: {},
        alternateRowStyles: {},
        columnStyles: {},
        // Properties
        startY: false,
        margin: 40 / scaleFactor,
        pageBreak: 'auto',
        tableWidth: 'auto',
        showHeader: 'everyPage',
        tableLineWidth: 0,
        tableLineColor: 200,
        // Hooks
        createdHeaderCell: function (cell, data) { },
        createdCell: function (cell, data) { },
        drawHeaderRow: function (row, data) { },
        drawRow: function (row, data) { },
        drawHeaderCell: function (cell, data) { },
        drawCell: function (cell, data) { },
        addPageContent: function (data) { }
    };
}
exports.getDefaults = getDefaults;
// Base style for all themes
function defaultStyles() {
    var scaleFactor = Config.scaleFactor();
    return {
        font: "helvetica",
        fontStyle: 'normal',
        overflow: 'ellipsize',
        fillColor: false,
        textColor: 20,
        halign: 'left',
        valign: 'top',
        fontSize: 10,
        cellPadding: 5 / scaleFactor,
        lineColor: 200,
        lineWidth: 0 / scaleFactor,
        columnWidth: 'auto'
    };
}
var Config = /** @class */ (function () {
    function Config() {
    }
    Config.pageSize = function () {
        var pageSize = table.doc.internal.pageSize;
        // JSPDF 1.4 uses get functions instead of properties on pageSize
        if (pageSize.width == null) {
            pageSize = {
                width: pageSize.getWidth(),
                height: pageSize.getHeight()
            };
        }
        return pageSize;
    };
    Config.applyUserStyles = function () {
        Config.applyStyles(table.userStyles);
    };
    Config.createTable = function (doc) {
        table = new models_1.Table(doc);
        return table;
    };
    Config.tableInstance = function () {
        return table;
    };
    Config.scaleFactor = function () {
        return table.doc.internal.scaleFactor;
    };
    Config.hooksData = function (additionalData) {
        if (additionalData === void 0) { additionalData = {}; }
        return assign({
            pageCount: table.pageCount,
            settings: table.settings,
            table: table,
            doc: table.doc,
            cursor: table.cursor
        }, additionalData || {});
    };
    Config.initSettings = function (table, allOptions) {
        var _loop_1 = function (styleProp) {
            var styles = allOptions.map(function (opts) { return opts[styleProp] || {}; });
            table.styles[styleProp] = assign.apply(void 0, [{}].concat(styles));
        };
        // Merge styles one level deeper
        for (var _i = 0, _a = Object.keys(table.styles); _i < _a.length; _i++) {
            var styleProp = _a[_i];
            _loop_1(styleProp);
        }
        // Append event handlers instead of replacing them
        for (var _b = 0, _c = entries(table.hooks); _b < _c.length; _b++) {
            var _d = _c[_b], hookName = _d[0], list = _d[1];
            for (var _e = 0, allOptions_1 = allOptions; _e < allOptions_1.length; _e++) {
                var opts = allOptions_1[_e];
                if (opts && opts[hookName]) {
                    list.push(opts[hookName]);
                }
            }
        }
        // Merge all other options one level
        table.settings = assign.apply(void 0, [getDefaults()].concat(allOptions));
    };
    // This is messy, only keep array and number format the next major version
    Config.marginOrPadding = function (value, defaultValue) {
        var newValue = {};
        if (Array.isArray(value)) {
            if (value.length >= 4) {
                newValue = { 'top': value[0], 'right': value[1], 'bottom': value[2], 'left': value[3] };
            }
            else if (value.length === 3) {
                newValue = { 'top': value[0], 'right': value[1], 'bottom': value[2], 'left': value[1] };
            }
            else if (value.length === 2) {
                newValue = { 'top': value[0], 'right': value[1], 'bottom': value[0], 'left': value[1] };
            }
            else if (value.length === 1) {
                value = value[0];
            }
            else {
                value = defaultValue;
            }
        }
        else if (typeof value === 'object') {
            if (value['vertical']) {
                value['top'] = value['vertical'];
                value['bottom'] = value['vertical'];
            }
            else if (value['horizontal']) {
                value['right'] = value['horizontal'];
                value['left'] = value['horizontal'];
            }
            for (var _i = 0, _a = ['top', 'right', 'bottom', 'left']; _i < _a.length; _i++) {
                var side = _a[_i];
                newValue[side] = value[side] || value[side] === 0 ? value[side] : defaultValue;
            }
        }
        if (typeof value === 'number') {
            newValue = { 'top': value, 'right': value, 'bottom': value, 'left': value };
        }
        return newValue;
    };
    Config.styles = function (styles) {
        styles = Array.isArray(styles) ? styles : [styles];
        return assign.apply(void 0, [defaultStyles()].concat(styles));
    };
    Config.applyStyles = function (styles) {
        var doc = table.doc;
        var styleModifiers = {
            fillColor: doc.setFillColor,
            textColor: doc.setTextColor,
            fontStyle: doc.setFontStyle,
            lineColor: doc.setDrawColor,
            lineWidth: doc.setLineWidth,
            font: doc.setFont,
            fontSize: doc.setFontSize
        };
        Object.keys(styleModifiers).forEach(function (name) {
            var style = styles[name];
            var modifier = styleModifiers[name];
            if (typeof style !== 'undefined') {
                if (Array.isArray(style)) {
                    modifier.apply(this, style);
                }
                else {
                    modifier(style);
                }
            }
        });
    };
    return Config;
}());
exports.Config = Config;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class /;
var isES6ClassFn = function isES6ClassFn(value) {
	try {
		var fnStr = fnToStr.call(value);
		var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
		var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
		var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
		return constructorRegex.test(spaceStripped);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionObject(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var implementation = __webpack_require__(29);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var config_1 = __webpack_require__(0);
var painter_1 = __webpack_require__(16);
function getStringWidth(text, styles) {
    var k = config_1.Config.scaleFactor();
    var fontSize = styles.fontSize / k;
    config_1.Config.applyStyles(styles);
    text = Array.isArray(text) ? text : [text];
    var maxWidth = 0;
    text.forEach(function (line) {
        var width = config_1.Config.tableInstance().doc.getStringUnitWidth(line);
        if (width > maxWidth) {
            maxWidth = width;
        }
    });
    var precision = 10000 * k;
    maxWidth = Math.floor(maxWidth * precision) / precision;
    return maxWidth * fontSize;
}
exports.getStringWidth = getStringWidth;
/**
 * Ellipsize the text to fit in the width
 */
function ellipsize(text, width, styles, ellipsizeStr) {
    if (ellipsizeStr === void 0) { ellipsizeStr = '...'; }
    if (Array.isArray(text)) {
        var value_1 = [];
        text.forEach(function (str, i) {
            value_1[i] = ellipsize(str, width, styles, ellipsizeStr);
        });
        return value_1;
    }
    var precision = 10000 * config_1.Config.scaleFactor();
    width = Math.ceil(width * precision) / precision;
    if (width >= getStringWidth(text, styles)) {
        return text;
    }
    while (width < getStringWidth(text + ellipsizeStr, styles)) {
        if (text.length <= 1) {
            break;
        }
        text = text.substring(0, text.length - 1);
    }
    return text.trim() + ellipsizeStr;
}
exports.ellipsize = ellipsize;
function addTableBorder() {
    var table = config_1.Config.tableInstance();
    var styles = { lineWidth: table.settings.tableLineWidth, lineColor: table.settings.tableLineColor };
    config_1.Config.applyStyles(styles);
    var fs = getFillStyle(styles);
    if (fs) {
        table.doc.rect(table.pageStartX, table.pageStartY, table.width, table.cursor.y - table.pageStartY, fs);
    }
}
exports.addTableBorder = addTableBorder;
function addPage() {
    var table = config_1.Config.tableInstance();
    table.finalY = table.cursor.y;
    // Add user content just before adding new page ensure it will 
    // be drawn above other things on the page
    addContentHooks();
    addTableBorder();
    nextPage(table.doc);
    table.pageCount++;
    table.cursor = { x: table.margin('left'), y: table.margin('top') };
    table.pageStartX = table.cursor.x;
    table.pageStartY = table.cursor.y;
    if (table.settings.showHeader === true || table.settings.showHeader === 'everyPage') {
        painter_1.printRow(table.headerRow, table.hooks.drawHeaderRow, table.hooks.drawHeaderCell);
    }
}
exports.addPage = addPage;
function addContentHooks() {
    for (var _i = 0, _a = config_1.Config.tableInstance().hooks.addPageContent; _i < _a.length; _i++) {
        var hook = _a[_i];
        config_1.Config.applyUserStyles();
        hook(config_1.Config.hooksData());
    }
    config_1.Config.applyUserStyles();
}
exports.addContentHooks = addContentHooks;
function getFillStyle(styles) {
    var drawLine = styles.lineWidth > 0;
    var drawBackground = styles.fillColor || styles.fillColor === 0;
    if (drawLine && drawBackground) {
        return 'DF'; // Fill then stroke
    }
    else if (drawLine) {
        return 'S'; // Only stroke (transparent background)
    }
    else if (drawBackground) {
        return 'F'; // Only fill, no stroke
    }
    else {
        return false;
    }
}
exports.getFillStyle = getFillStyle;
function nextPage(doc) {
    var current = doc.internal.getCurrentPageInfo().pageNumber;
    doc.setPage(current + 1);
    var newCurrent = doc.internal.getCurrentPageInfo().pageNumber;
    if (newCurrent === current) {
        doc.addPage();
    }
}
exports.nextPage = nextPage;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var config_1 = __webpack_require__(0);
exports.table = {};
var Table = /** @class */ (function () {
    function Table(doc) {
        this.height = 0;
        this.width = 0;
        this.contentWidth = 0;
        this.preferredWidth = 0;
        this.rows = [];
        this.columns = [];
        this.headerRow = null;
        this.pageCount = 1;
        this.hooks = {
            createdHeaderCell: [],
            createdCell: [],
            drawHeaderRow: [],
            drawRow: [],
            drawHeaderCell: [],
            drawCell: [],
            addPageContent: []
        };
        this.styles = {
            styles: {},
            headerStyles: {},
            bodyStyles: {},
            alternateRowStyles: {},
            columnStyles: {}
        };
        this.doc = doc;
        this.userStyles = {
            textColor: 30,
            fontSize: doc.internal.getFontSize(),
            fontStyle: doc.internal.getFont().fontStyle
        };
    }
    Table.prototype.margin = function (side) {
        return config_1.Config.marginOrPadding(this.settings.margin, config_1.getDefaults().margin)[side];
    };
    return Table;
}());
exports.Table = Table;
var Row = /** @class */ (function () {
    function Row(raw, index) {
        this.cells = {};
        this.spansMultiplePages = false;
        this.pageCount = 1;
        this.height = 0;
        this.y = 0;
        this.maxLineCount = 1;
        this.raw = raw;
        this.index = index;
    }
    return Row;
}());
exports.Row = Row;
var Cell = /** @class */ (function () {
    function Cell(raw) {
        this.styles = {};
        this.text = '';
        this.contentWidth = 0;
        this.textPos = {};
        this.height = 0;
        this.width = 0;
        this.x = 0;
        this.y = 0;
        this.raw = raw;
    }
    Cell.prototype.padding = function (name) {
        var padding = config_1.Config.marginOrPadding(this.styles.cellPadding, config_1.Config.styles([]).cellPadding);
        if (name === 'vertical') {
            return padding.top + padding.bottom;
        }
        else if (name === 'horizontal') {
            return padding.left + padding.right;
        }
        else {
            return padding[name];
        }
    };
    return Cell;
}());
exports.Cell = Cell;
var Column = /** @class */ (function () {
    function Column(dataKey, index) {
        this.options = {};
        this.contentWidth = 0;
        this.preferredWidth = 0;
        this.widthStyle = 'auto';
        this.width = 0;
        this.x = 0;
        this.dataKey = dataKey;
        this.index = index;
    }
    return Column;
}());
exports.Column = Column;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(20);
var foreach = __webpack_require__(22);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

var toStr = Object.prototype.toString;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
        /* eslint-disable no-unused-vars, no-restricted-syntax */
        for (var _ in obj) { return false; }
        /* eslint-enable no-unused-vars, no-restricted-syntax */
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		Object.defineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = props.concat(Object.getOwnPropertySymbols(map));
	}
	foreach(props, function (name) {
		defineProperty(object, name, map[name], predicates[name]);
	});
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES = __webpack_require__(23);
var has = __webpack_require__(14);
var bind = __webpack_require__(2);
var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);

module.exports = function entries(O) {
	var obj = ES.RequireObjectCoercible(O);
	var entrys = [];
	for (var key in obj) {
		if (has(obj, key) && isEnumerable(obj, key)) {
			entrys.push([key, obj[key]]);
		}
	}
	return entrys;
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 10 */
/***/ (function(module, exports) {

var has = Object.prototype.hasOwnProperty;
module.exports = Object.assign || function assign(target, source) {
	for (var key in source) {
		if (has.call(source, key)) {
			target[key] = source[key];
		}
	}
	return target;
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(2);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(7);

module.exports = function getPolyfill() {
	return typeof Object.entries === 'function' ? Object.entries : implementation;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var config_1 = __webpack_require__(0);
var common_1 = __webpack_require__(3);
function printFullRow(row, drawRowHooks, drawCellHooks) {
    var remainingRowHeight = 0;
    var remainingTexts = {};
    var table = config_1.Config.tableInstance();
    if (!canFitOnPage(row.height)) {
        if (row.maxLineCount <= 1) {
            common_1.addPage();
        }
        else {
            // Modify the row to fit the current page and calculate text and height of partial row
            row.spansMultiplePages = true;
            var pageHeight = config_1.Config.pageSize().height;
            var maxCellHeight = 0;
            for (var j = 0; j < table.columns.length; j++) {
                var col = table.columns[j];
                var cell = row.cells[col.dataKey];
                var fontHeight = cell.styles.fontSize / config_1.Config.scaleFactor() * config_1.FONT_ROW_RATIO;
                var vPadding = cell.padding('vertical');
                var remainingPageSpace = pageHeight - table.cursor.y - table.margin('bottom');
                var remainingLineCount = Math.floor((remainingPageSpace - vPadding) / fontHeight);
                // Splice with negative values results in unexpected results, therefore eliminate
                // scenarios where less than one line is remaining, but are shown
                if (remainingLineCount < 0) {
                    remainingLineCount = 0;
                }
                if (Array.isArray(cell.text) && cell.text.length > remainingLineCount) {
                    var remainingLines = cell.text.splice(remainingLineCount, cell.text.length);
                    remainingTexts[col.dataKey] = remainingLines;
                    var cellHeight = cell.text.length * fontHeight + vPadding;
                    if (cellHeight > maxCellHeight) {
                        maxCellHeight = cellHeight;
                    }
                    var rCellHeight = remainingLines.length * fontHeight + vPadding;
                    if (rCellHeight > remainingRowHeight) {
                        remainingRowHeight = rCellHeight;
                    }
                }
            }
            // Reset row height since text are now removed
            row.height = maxCellHeight;
        }
    }
    printRow(row, drawRowHooks, drawCellHooks);
    // Parts of the row is now printed. Time for adding a new page, prune 
    // the text and start over
    if (Object.keys(remainingTexts).length > 0) {
        for (var j = 0; j < table.columns.length; j++) {
            var col = table.columns[j];
            var cell = row.cells[col.dataKey];
            cell.text = remainingTexts[col.dataKey] || '';
        }
        common_1.addPage();
        row.pageCount++;
        row.height = remainingRowHeight;
        printFullRow(row, drawRowHooks, drawCellHooks);
    }
}
exports.printFullRow = printFullRow;
function printRow(row, drawRowHooks, drawCellHooks) {
    var table = config_1.Config.tableInstance();
    row.y = table.cursor.y;
    for (var _i = 0, drawRowHooks_1 = drawRowHooks; _i < drawRowHooks_1.length; _i++) {
        var hook = drawRowHooks_1[_i];
        if (hook(row, config_1.Config.hooksData({ row: row, addPage: common_1.addPage })) === false) {
            return;
        }
    }
    table.cursor.x = table.margin('left');
    for (var i = 0; i < table.columns.length; i++) {
        var column = table.columns[i];
        var cell = row.cells[column.dataKey];
        if (!cell) {
            continue;
        }
        config_1.Config.applyStyles(cell.styles);
        cell.x = table.cursor.x;
        cell.y = table.cursor.y;
        cell.height = row.height;
        cell.width = column.width;
        if (cell.styles.valign === 'top') {
            cell.textPos.y = table.cursor.y + cell.padding('top');
        }
        else if (cell.styles.valign === 'bottom') {
            cell.textPos.y = table.cursor.y + row.height - cell.padding('bottom');
        }
        else {
            cell.textPos.y = table.cursor.y + row.height / 2;
        }
        if (cell.styles.halign === 'right') {
            cell.textPos.x = cell.x + cell.width - cell.padding('right');
        }
        else if (cell.styles.halign === 'center') {
            cell.textPos.x = cell.x + cell.width / 2;
        }
        else {
            cell.textPos.x = cell.x + cell.padding('left');
        }
        var shouldDrawCell = true;
        var data = config_1.Config.hooksData({ column: column, row: row, addPage: common_1.addPage });
        for (var _a = 0, drawCellHooks_1 = drawCellHooks; _a < drawCellHooks_1.length; _a++) {
            var hook = drawCellHooks_1[_a];
            if (hook(cell, data) === false) {
                shouldDrawCell = false;
            }
        }
        if (shouldDrawCell) {
            var fillStyle = common_1.getFillStyle(cell.styles);
            if (fillStyle) {
                table.doc.rect(cell.x, cell.y, cell.width, cell.height, fillStyle);
            }
            table.doc.autoTableText(cell.text, cell.textPos.x, cell.textPos.y, {
                halign: cell.styles.halign,
                valign: cell.styles.valign
            });
        }
        table.cursor.x += cell.width;
    }
    table.cursor.y += row.height;
}
exports.printRow = printRow;
function canFitOnPage(rowHeight) {
    var table = config_1.Config.tableInstance();
    var pos = rowHeight + table.cursor.y + table.margin('bottom');
    return pos < config_1.Config.pageSize().height;
}


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var jsPDF = __webpack_require__(18);
var config_1 = __webpack_require__(0);
var common_1 = __webpack_require__(3);
var painter_1 = __webpack_require__(16);
var calculator_1 = __webpack_require__(34);
var creator_1 = __webpack_require__(35);
/**
 * Create a table from a set of rows and columns.
 *
 * @param {Object[]|String[]} headers Either as an array of objects or array of strings
 * @param {Object[][]|String[][]} data Either as an array of objects or array of strings
 * @param {Object} [tableOptions={}] Options that will override the default ones
 */
jsPDF.API.autoTable = function (headers, data, tableOptions) {
    if (tableOptions === void 0) { tableOptions = {}; }
    this.autoTableState = this.autoTableState || {};
    jsPDF.autoTableState = jsPDF.autoTableState || {};
    var allOptions = [jsPDF.autoTableState.defaults || {}, this.autoTableState.defaults || {}, tableOptions || {}];
    creator_1.validateInput(headers, data, allOptions);
    var table = config_1.Config.createTable(this);
    config_1.Config.initSettings(table, allOptions);
    var settings = table.settings;
    // Create the table model with its columns, rows and cells
    creator_1.createModels(headers, data);
    settings.margin = config_1.Config.marginOrPadding(settings.margin, config_1.getDefaults().margin);
    calculator_1.calculateWidths(this, config_1.Config.pageSize().width);
    table.cursor = {
        x: table.margin('left'),
        y: settings.startY === false ? table.margin('top') : settings.startY
    };
    var minTableBottomPos = settings.startY + table.margin('bottom') + table.headerRow.height;
    if (settings.pageBreak === 'avoid') {
        minTableBottomPos += table.height;
    }
    var pageHeight = config_1.Config.pageSize().height;
    if ((settings.pageBreak === 'always' && settings.startY !== false) ||
        (settings.startY !== false && minTableBottomPos > pageHeight)) {
        common_1.nextPage(table.doc);
        table.cursor.y = table.margin('top');
    }
    table.pageStartX = table.cursor.x;
    table.pageStartY = table.cursor.y;
    config_1.Config.applyUserStyles();
    if (settings.showHeader === true || settings.showHeader === 'firstPage' || settings.showHeader === 'everyPage') {
        painter_1.printRow(table.headerRow, table.hooks.drawHeaderRow, table.hooks.drawHeaderCell);
    }
    config_1.Config.applyUserStyles();
    table.rows.forEach(function (row) {
        painter_1.printFullRow(row, table.hooks.drawRow, table.hooks.drawCell);
    });
    common_1.addTableBorder();
    // Don't call global and document addPageContent more than once for each page
    var pageNumber = this.internal.getCurrentPageInfo().pageNumber;
    if (this.autoTableState.addPageHookPages && this.autoTableState.addPageHookPages[pageNumber]) {
        if (typeof tableOptions['addPageContent'] === 'function') {
            tableOptions['addPageContent'](config_1.Config.hooksData());
        }
    }
    else {
        if (!this.autoTableState.addPageHookPages)
            this.autoTableState.addPageHookPages = {};
        this.autoTableState.addPageHookPages[pageNumber] = true;
        common_1.addContentHooks();
    }
    table.finalY = table.cursor.y;
    this.autoTable.previous = table;
    config_1.Config.applyUserStyles();
    return this;
};
// Enables doc.autoTable.previous.finalY || 40;
jsPDF.API.autoTable.previous = false;
jsPDF.API.autoTableSetDefaults = function (defaults) {
    if (!this.autoTableState)
        this.autoTableState = {};
    if (defaults && typeof defaults === 'object') {
        this.autoTableState.defaults = defaults;
    }
    else {
        delete this.autoTableState.defaults;
    }
    return this;
};
jsPDF.autoTableSetDefaults = function (defaults) {
    if (!jsPDF.autoTableState)
        jsPDF.autoTableState = {};
    if (defaults && typeof defaults === 'object') {
        this.autoTableState.defaults = defaults;
    }
    else {
        delete this.autoTableState.defaults;
    }
    jsPDF.autoTableState.defaults = defaults;
};
/**
 * Parses an html table
 *
 * @param tableElem Html table element
 * @param includeHiddenElements If to include hidden rows and columns (defaults to false)
 * @returns Object Object with two properties, columns and rows
 */
jsPDF.API.autoTableHtmlToJson = function (tableElem, includeHiddenElements) {
    includeHiddenElements = includeHiddenElements || false;
    if (!tableElem || !(tableElem instanceof HTMLTableElement)) {
        console.error("A HTMLTableElement has to be sent to autoTableHtmlToJson");
        return null;
    }
    var columns = {}, rows = [];
    var header = tableElem.rows[0];
    for (var i = 0; i < header.cells.length; i++) {
        var cell = header.cells[i];
        var style = window.getComputedStyle(cell);
        if (includeHiddenElements || style.display !== 'none') {
            columns[i] = cell;
        }
    }
    var _loop_1 = function (i) {
        var tableRow = tableElem.rows[i];
        var style = window.getComputedStyle(tableRow);
        if (includeHiddenElements || style.display !== 'none') {
            var rowData_1 = [];
            Object.keys(columns).forEach(function (key) {
                var cell = tableRow.cells[key];
                rowData_1.push(cell);
            });
            rows.push(rowData_1);
        }
    };
    for (var i = 1; i < tableElem.rows.length; i++) {
        _loop_1(i);
    }
    var values = Object.keys(columns).map(function (key) { return columns[key]; });
    return { columns: values, rows: rows, data: rows };
};
/**
 * Improved text function with halign and valign support
 * Inspiration from: http://stackoverflow.com/questions/28327510/align-text-right-using-jspdf/28433113#28433113
 */
jsPDF.API.autoTableText = function (text, x, y, styles) {
    if (typeof x !== 'number' || typeof y !== 'number') {
        console.error('The x and y parameters are required. Missing for the text: ', text);
    }
    var k = this.internal.scaleFactor;
    var fontSize = this.internal.getFontSize() / k;
    var splitRegex = /\r\n|\r|\n/g;
    var splitText = null;
    var lineCount = 1;
    if (styles.valign === 'middle' || styles.valign === 'bottom' || styles.halign === 'center' || styles.halign === 'right') {
        splitText = typeof text === 'string' ? text.split(splitRegex) : text;
        lineCount = splitText.length || 1;
    }
    // Align the top
    y += fontSize * (2 - config_1.FONT_ROW_RATIO);
    if (styles.valign === 'middle')
        y -= (lineCount / 2) * fontSize * config_1.FONT_ROW_RATIO;
    else if (styles.valign === 'bottom')
        y -= lineCount * fontSize * config_1.FONT_ROW_RATIO;
    if (styles.halign === 'center' || styles.halign === 'right') {
        var alignSize = fontSize;
        if (styles.halign === 'center')
            alignSize *= 0.5;
        if (lineCount >= 1) {
            for (var iLine = 0; iLine < splitText.length; iLine++) {
                this.text(splitText[iLine], x - this.getStringUnitWidth(splitText[iLine]) * alignSize, y);
                y += fontSize;
            }
            return this;
        }
        x -= this.getStringUnitWidth(text) * alignSize;
    }
    this.text(text, x, y);
    return this;
};
/**
 * @deprecated Use doc.autoTable.previous.finalY instead
 */
jsPDF.API.autoTableEndPosY = function () {
    var prev = this.autoTable.previous;
    if (prev.cursor && typeof prev.cursor.y === 'number') {
        return prev.cursor.y;
    }
    else {
        return 0;
    }
};
/**
 * @deprecated Use jsPDF.autoTableSetDefaults({addPageContent: function() {}}) instead
 */
jsPDF.API.autoTableAddPageContent = function (hook) {
    if (!jsPDF.API.autoTable.globalDefaults) {
        jsPDF.API.autoTable.globalDefaults = {};
    }
    jsPDF.API.autoTable.globalDefaults.addPageContent = hook;
    return this;
};
/**
 * @deprecated Use data.addPage in hooks instead
 */
jsPDF.API.autoTableAddPage = function () {
    common_1.addPage();
    return this;
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__18__;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(6);

var implementation = __webpack_require__(7);
var getPolyfill = __webpack_require__(15);
var shim = __webpack_require__(33);

var polyfill = getPolyfill();

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es5-shim
var has = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var slice = Array.prototype.slice;
var isArgs = __webpack_require__(21);
var isEnumerable = Object.prototype.propertyIsEnumerable;
var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
var dontEnums = [
	'toString',
	'toLocaleString',
	'valueOf',
	'hasOwnProperty',
	'isPrototypeOf',
	'propertyIsEnumerable',
	'constructor'
];
var equalsConstructorPrototype = function (o) {
	var ctor = o.constructor;
	return ctor && ctor.prototype === o;
};
var excludedKeys = {
	$console: true,
	$external: true,
	$frame: true,
	$frameElement: true,
	$frames: true,
	$innerHeight: true,
	$innerWidth: true,
	$outerHeight: true,
	$outerWidth: true,
	$pageXOffset: true,
	$pageYOffset: true,
	$parent: true,
	$scrollLeft: true,
	$scrollTop: true,
	$scrollX: true,
	$scrollY: true,
	$self: true,
	$webkitIndexedDB: true,
	$webkitStorageInfo: true,
	$window: true
};
var hasAutomationEqualityBug = (function () {
	/* global window */
	if (typeof window === 'undefined') { return false; }
	for (var k in window) {
		try {
			if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
				try {
					equalsConstructorPrototype(window[k]);
				} catch (e) {
					return true;
				}
			}
		} catch (e) {
			return true;
		}
	}
	return false;
}());
var equalsConstructorPrototypeIfNotBuggy = function (o) {
	/* global window */
	if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
		return equalsConstructorPrototype(o);
	}
	try {
		return equalsConstructorPrototype(o);
	} catch (e) {
		return false;
	}
};

var keysShim = function keys(object) {
	var isObject = object !== null && typeof object === 'object';
	var isFunction = toStr.call(object) === '[object Function]';
	var isArguments = isArgs(object);
	var isString = isObject && toStr.call(object) === '[object String]';
	var theKeys = [];

	if (!isObject && !isFunction && !isArguments) {
		throw new TypeError('Object.keys called on a non-object');
	}

	var skipProto = hasProtoEnumBug && isFunction;
	if (isString && object.length > 0 && !has.call(object, 0)) {
		for (var i = 0; i < object.length; ++i) {
			theKeys.push(String(i));
		}
	}

	if (isArguments && object.length > 0) {
		for (var j = 0; j < object.length; ++j) {
			theKeys.push(String(j));
		}
	} else {
		for (var name in object) {
			if (!(skipProto && name === 'prototype') && has.call(object, name)) {
				theKeys.push(String(name));
			}
		}
	}

	if (hasDontEnumBug) {
		var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

		for (var k = 0; k < dontEnums.length; ++k) {
			if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
				theKeys.push(dontEnums[k]);
			}
		}
	}
	return theKeys;
};

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			return (Object.keys(arguments) || '').length === 2;
		}(1, 2));
		if (!keysWorksWithArguments) {
			var originalKeys = Object.keys;
			Object.keys = function keys(object) {
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				} else {
					return originalKeys(object);
				}
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {


var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

module.exports = function forEach (obj, fn, ctx) {
    if (toString.call(fn) !== '[object Function]') {
        throw new TypeError('iterator must be a function');
    }
    var l = obj.length;
    if (l === +l) {
        for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
        }
    } else {
        for (var k in obj) {
            if (hasOwn.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
            }
        }
    }
};



/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES6 = __webpack_require__(24);
var assign = __webpack_require__(10);

var ES7 = assign(ES6, {
	// https://github.com/tc39/ecma262/pull/60
	SameValueNonNumber: function SameValueNonNumber(x, y) {
		if (typeof x === 'number' || typeof x !== typeof y) {
			throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
		}
		return this.SameValue(x, y);
	}
});

module.exports = ES7;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
var symbolToStr = hasSymbols ? Symbol.prototype.toString : toStr;

var $isNaN = __webpack_require__(8);
var $isFinite = __webpack_require__(9);
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

var assign = __webpack_require__(10);
var sign = __webpack_require__(11);
var mod = __webpack_require__(12);
var isPrimitive = __webpack_require__(25);
var toPrimitive = __webpack_require__(26);
var parseInteger = parseInt;
var bind = __webpack_require__(2);
var strSlice = bind.call(Function.call, String.prototype.slice);
var isBinary = bind.call(Function.call, RegExp.prototype.test, /^0b[01]+$/i);
var isOctal = bind.call(Function.call, RegExp.prototype.test, /^0o[0-7]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
var hasNonWS = bind.call(Function.call, RegExp.prototype.test, nonWSregex);
var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
var isInvalidHexLiteral = bind.call(Function.call, RegExp.prototype.test, invalidHexLiteral);

// whitespace from: http://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var replace = bind.call(Function.call, String.prototype.replace);
var trim = function (value) {
	return replace(value, trimRegex, '');
};

var ES5 = __webpack_require__(30);

var hasRegExpMatcher = __webpack_require__(32);

// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
var ES6 = assign(assign({}, ES5), {

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
	Call: function Call(F, V) {
		var args = arguments.length > 2 ? arguments[2] : [];
		if (!this.IsCallable(F)) {
			throw new TypeError(F + ' is not a function');
		}
		return F.apply(V, args);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
	ToPrimitive: toPrimitive,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
	// ToBoolean: ES5.ToBoolean,

	// http://www.ecma-international.org/ecma-262/6.0/#sec-tonumber
	ToNumber: function ToNumber(argument) {
		var value = isPrimitive(argument) ? argument : toPrimitive(argument, 'number');
		if (typeof value === 'symbol') {
			throw new TypeError('Cannot convert a Symbol value to a number');
		}
		if (typeof value === 'string') {
			if (isBinary(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 2));
			} else if (isOctal(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 8));
			} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
				return NaN;
			} else {
				var trimmed = trim(value);
				if (trimmed !== value) {
					return this.ToNumber(trimmed);
				}
			}
		}
		return Number(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
	// ToInteger: ES5.ToNumber,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
	// ToInt32: ES5.ToInt32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
	// ToUint32: ES5.ToUint32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
	ToInt16: function ToInt16(argument) {
		var int16bit = this.ToUint16(argument);
		return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
	// ToUint16: ES5.ToUint16,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
	ToInt8: function ToInt8(argument) {
		var int8bit = this.ToUint8(argument);
		return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
	ToUint8: function ToUint8(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x100);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
	ToUint8Clamp: function ToUint8Clamp(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number <= 0) { return 0; }
		if (number >= 0xFF) { return 0xFF; }
		var f = Math.floor(argument);
		if (f + 0.5 < number) { return f + 1; }
		if (number < f + 0.5) { return f; }
		if (f % 2 !== 0) { return f + 1; }
		return f;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
	ToString: function ToString(argument) {
		if (typeof argument === 'symbol') {
			throw new TypeError('Cannot convert a Symbol value to a string');
		}
		return String(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
	ToObject: function ToObject(value) {
		this.RequireObjectCoercible(value);
		return Object(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
	ToPropertyKey: function ToPropertyKey(argument) {
		var key = this.ToPrimitive(argument, String);
		return typeof key === 'symbol' ? symbolToStr.call(key) : this.ToString(key);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	ToLength: function ToLength(argument) {
		var len = this.ToInteger(argument);
		if (len <= 0) { return 0; } // includes converting -0 to +0
		if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
		return len;
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
	CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
		if (toStr.call(argument) !== '[object String]') {
			throw new TypeError('must be a string');
		}
		if (argument === '-0') { return -0; }
		var n = this.ToNumber(argument);
		if (this.SameValue(this.ToString(n), argument)) { return n; }
		return void 0;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
	RequireObjectCoercible: ES5.CheckObjectCoercible,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
	IsArray: Array.isArray || function IsArray(argument) {
		return toStr.call(argument) === '[object Array]';
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
	// IsCallable: ES5.IsCallable,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
	IsConstructor: function IsConstructor(argument) {
		return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
	IsExtensible: function IsExtensible(obj) {
		if (!Object.preventExtensions) { return true; }
		if (isPrimitive(obj)) {
			return false;
		}
		return Object.isExtensible(obj);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
	IsInteger: function IsInteger(argument) {
		if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
			return false;
		}
		var abs = Math.abs(argument);
		return Math.floor(abs) === abs;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
	IsPropertyKey: function IsPropertyKey(argument) {
		return typeof argument === 'string' || typeof argument === 'symbol';
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-isregexp
	IsRegExp: function IsRegExp(argument) {
		if (!argument || typeof argument !== 'object') {
			return false;
		}
		if (hasSymbols) {
			var isRegExp = argument[Symbol.match];
			if (typeof isRegExp !== 'undefined') {
				return ES5.ToBoolean(isRegExp);
			}
		}
		return hasRegExpMatcher(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
	// SameValue: ES5.SameValue,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
	SameValueZero: function SameValueZero(x, y) {
		return (x === y) || ($isNaN(x) && $isNaN(y));
	},

	/**
	 * 7.3.2 GetV (V, P)
	 * 1. Assert: IsPropertyKey(P) is true.
	 * 2. Let O be ToObject(V).
	 * 3. ReturnIfAbrupt(O).
	 * 4. Return O.[[Get]](P, V).
	 */
	GetV: function GetV(V, P) {
		// 7.3.2.1
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.2.2-3
		var O = this.ToObject(V);

		// 7.3.2.4
		return O[P];
	},

	/**
	 * 7.3.9 - http://www.ecma-international.org/ecma-262/6.0/#sec-getmethod
	 * 1. Assert: IsPropertyKey(P) is true.
	 * 2. Let func be GetV(O, P).
	 * 3. ReturnIfAbrupt(func).
	 * 4. If func is either undefined or null, return undefined.
	 * 5. If IsCallable(func) is false, throw a TypeError exception.
	 * 6. Return func.
	 */
	GetMethod: function GetMethod(O, P) {
		// 7.3.9.1
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.9.2
		var func = this.GetV(O, P);

		// 7.3.9.4
		if (func == null) {
			return undefined;
		}

		// 7.3.9.5
		if (!this.IsCallable(func)) {
			throw new TypeError(P + 'is not a function');
		}

		// 7.3.9.6
		return func;
	},

	/**
	 * 7.3.1 Get (O, P) - http://www.ecma-international.org/ecma-262/6.0/#sec-get-o-p
	 * 1. Assert: Type(O) is Object.
	 * 2. Assert: IsPropertyKey(P) is true.
	 * 3. Return O.[[Get]](P, O).
	 */
	Get: function Get(O, P) {
		// 7.3.1.1
		if (this.Type(O) !== 'Object') {
			throw new TypeError('Assertion failed: Type(O) is not Object');
		}
		// 7.3.1.2
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		// 7.3.1.3
		return O[P];
	},

	Type: function Type(x) {
		if (typeof x === 'symbol') {
			return 'Symbol';
		}
		return ES5.Type(x);
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
	SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('Assertion failed: Type(O) is not Object');
		}
		var C = O.constructor;
		if (typeof C === 'undefined') {
			return defaultConstructor;
		}
		if (this.Type(C) !== 'Object') {
			throw new TypeError('O.constructor is not an Object');
		}
		var S = hasSymbols && Symbol.species ? C[Symbol.species] : undefined;
		if (S == null) {
			return defaultConstructor;
		}
		if (this.IsConstructor(S)) {
			return S;
		}
		throw new TypeError('no constructor found');
	}
});

delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible

module.exports = ES6;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var isPrimitive = __webpack_require__(13);
var isCallable = __webpack_require__(1);
var isDate = __webpack_require__(27);
var isSymbol = __webpack_require__(28);

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (PreferredType === String) {
			hint = 'string';
		} else if (PreferredType === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDate(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateObject(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) { return false; }
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') { return false; }
		return symStringRegex.test(symToStr.call(value));
	};
	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') { return true; }
		if (toStr.call(value) !== '[object Symbol]') { return false; }
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {
	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false;
	};
}


/***/ }),
/* 29 */
/***/ (function(module, exports) {

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(8);
var $isFinite = __webpack_require__(9);

var sign = __webpack_require__(11);
var mod = __webpack_require__(12);

var IsCallable = __webpack_require__(1);
var toPrimitive = __webpack_require__(31);

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return Boolean(value);
	},
	ToNumber: function ToNumber(value) {
		return Number(value);
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// http://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	}
};

module.exports = ES5;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(13);

var isCallable = __webpack_require__(1);

// https://es5.github.io/#x8.12
var ES5internalSlots = {
	'[[DefaultValue]]': function (O, hint) {
		var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// https://es5.github.io/#x9
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(14);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0;

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex;
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(15);
var define = __webpack_require__(6);

module.exports = function shimEntries() {
	var polyfill = getPolyfill();
	define(Object, { entries: polyfill }, {
		entries: function testEntries() {
			return Object.entries !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var config_1 = __webpack_require__(0);
var common_1 = __webpack_require__(3);
/**
 * Calculate the column widths
 */
function calculateWidths(doc, pageWidth) {
    var table = config_1.Config.tableInstance();
    // Column and table content width
    var fixedWidth = 0;
    var autoWidth = 0;
    var dynamicColumns = [];
    table.columns.forEach(function (column) {
        column.contentWidth = 0;
        table.rows.concat(table.headerRow).forEach(function (row) {
            var cell = row.cells[column.dataKey];
            cell.contentWidth = cell.padding('horizontal') + common_1.getStringWidth(cell.text, cell.styles);
            if (cell.contentWidth > column.contentWidth) {
                column.contentWidth = cell.contentWidth;
            }
        });
        table.contentWidth += column.contentWidth;
        if (typeof column.widthStyle === 'number') {
            column.preferredWidth = column.widthStyle;
            fixedWidth += column.preferredWidth;
            column.width = column.preferredWidth;
        }
        else if (column.widthStyle === 'wrap') {
            column.preferredWidth = column.contentWidth;
            fixedWidth += column.preferredWidth;
            column.width = column.preferredWidth;
        }
        else {
            column.preferredWidth = column.contentWidth;
            autoWidth += column.contentWidth;
            dynamicColumns.push(column);
        }
        table.preferredWidth += column.preferredWidth;
    });
    if (typeof table.settings.tableWidth === 'number') {
        table.width = table.settings.tableWidth;
    }
    else if (table.settings.tableWidth === 'wrap') {
        table.width = table.preferredWidth;
    }
    else {
        table.width = pageWidth - table.margin('left') - table.margin('right');
    }
    distributeWidth(dynamicColumns, fixedWidth, autoWidth, 0);
    // Row height, table height and text overflow
    var all = table.rows.concat(table.headerRow);
    all.forEach(function (row) {
        table.columns.forEach(function (col) {
            var cell = row.cells[col.dataKey];
            config_1.Config.applyStyles(cell.styles);
            var textSpace = col.width - cell.padding('horizontal');
            var k = config_1.Config.scaleFactor();
            if (cell.styles.overflow === 'linebreak') {
                // Add one pt to textSpace to fix rounding error
                try {
                    cell.text = doc.splitTextToSize(cell.text, textSpace + 1 / k, { fontSize: cell.styles.fontSize });
                }
                catch (e) {
                    if (e instanceof TypeError && Array.isArray(cell.text)) {
                        cell.text = doc.splitTextToSize(cell.text.join(' '), textSpace + 1 / k, { fontSize: cell.styles.fontSize });
                    }
                    else {
                        throw e;
                    }
                }
            }
            else if (cell.styles.overflow === 'ellipsize') {
                cell.text = common_1.ellipsize(cell.text, textSpace, cell.styles);
            }
            else if (cell.styles.overflow === 'visible') {
                // Do nothing
            }
            else if (cell.styles.overflow === 'hidden') {
                cell.text = common_1.ellipsize(cell.text, textSpace, cell.styles, '');
            }
            else if (typeof cell.styles.overflow === 'function') {
                cell.text = cell.styles.overflow(cell.text, textSpace);
            }
            else {
                console.error("Unrecognized overflow type: " + cell.styles.overflow);
            }
            var lineCount = Array.isArray(cell.text) ? cell.text.length : 1;
            var fontHeight = cell.styles.fontSize / k * config_1.FONT_ROW_RATIO;
            cell.contentHeight = lineCount * fontHeight + cell.padding('vertical');
            if (cell.contentHeight > row.height) {
                row.height = cell.contentHeight;
                row.maxLineCount = lineCount;
            }
        });
        table.height += row.height;
    });
}
exports.calculateWidths = calculateWidths;
function distributeWidth(dynamicColumns, staticWidth, dynamicColumnsContentWidth, fairWidth) {
    var table = config_1.Config.tableInstance();
    var extraWidth = table.width - staticWidth - dynamicColumnsContentWidth;
    for (var i = 0; i < dynamicColumns.length; i++) {
        var col = dynamicColumns[i];
        var ratio = col.contentWidth / dynamicColumnsContentWidth;
        // A column turned out to be none dynamic, start over recursively
        var isNoneDynamic = col.contentWidth + extraWidth * ratio < fairWidth;
        if (extraWidth < 0 && isNoneDynamic) {
            dynamicColumns.splice(i, 1);
            dynamicColumnsContentWidth -= col.contentWidth;
            col.width = fairWidth;
            staticWidth += col.width;
            distributeWidth(dynamicColumns, staticWidth, dynamicColumnsContentWidth, fairWidth);
            break;
        }
        else {
            col.width = col.contentWidth + extraWidth * ratio;
        }
    }
}


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__(4);
var config_1 = __webpack_require__(0);
var assign = __webpack_require__(5);
function validateInput(headers, data, allOptions) {
    if (!headers || typeof headers !== 'object') {
        console.error("The headers should be an object or array, is: " + typeof headers);
    }
    if (!data || typeof data !== 'object') {
        console.error("The data should be an object or array, is: " + typeof data);
    }
    var _loop_1 = function (settings) {
        if (settings && typeof settings !== 'object') {
            console.error("The options parameter should be of type object, is: " + typeof settings);
        }
        if (typeof settings.extendWidth !== 'undefined') {
            settings.tableWidth = settings.extendWidth ? 'auto' : 'wrap';
            console.error("Use of deprecated option: extendWidth, use tableWidth instead.");
        }
        if (typeof settings.margins !== 'undefined') {
            if (typeof settings.margin === 'undefined')
                settings.margin = settings.margins;
            console.error("Use of deprecated option: margins, use margin instead.");
        }
        if (typeof settings.afterPageContent !== 'undefined' || typeof settings.beforePageContent !== 'undefined' || typeof settings.afterPageAdd !== 'undefined') {
            console.error("The afterPageContent, beforePageContent and afterPageAdd hooks are deprecated. Use addPageContent instead");
            if (typeof settings.addPageContent === 'undefined') {
                settings.addPageContent = function (data) {
                    config_1.Config.applyUserStyles();
                    if (settings.beforePageContent)
                        settings.beforePageContent(data);
                    config_1.Config.applyUserStyles();
                    if (settings.afterPageContent)
                        settings.afterPageContent(data);
                    config_1.Config.applyUserStyles();
                    if (settings.afterPageAdd && data.pageCount > 1) {
                        data.afterPageAdd(data);
                    }
                    config_1.Config.applyUserStyles();
                };
            }
        }
        [['padding', 'cellPadding'], ['lineHeight', 'rowHeight'], 'fontSize', 'overflow'].forEach(function (o) {
            var deprecatedOption = typeof o === 'string' ? o : o[0];
            var style = typeof o === 'string' ? o : o[1];
            if (typeof settings[deprecatedOption] !== 'undefined') {
                if (typeof settings.styles[style] === 'undefined') {
                    settings.styles[style] = settings[deprecatedOption];
                }
                console.error("Use of deprecated option: " + deprecatedOption + ", use the style " + style + " instead.");
            }
        });
        for (var _i = 0, _a = ['styles', 'bodyStyles', 'headerStyles', 'columnStyles']; _i < _a.length; _i++) {
            var styleProp = _a[_i];
            if (settings[styleProp] && typeof settings[styleProp] !== 'object') {
                console.error("The " + styleProp + " style should be of type object, is: " + typeof settings[styleProp]);
            }
            else if (settings[styleProp] && settings[styleProp].rowHeight) {
                console.error("Use of deprecated style: rowHeight, use vertical cell padding instead");
            }
        }
    };
    for (var _i = 0, allOptions_1 = allOptions; _i < allOptions_1.length; _i++) {
        var settings = allOptions_1[_i];
        _loop_1(settings);
    }
}
exports.validateInput = validateInput;
/**
 * Create models from the user input
 *
 * @param inputHeaders
 * @param inputData
 */
function createModels(inputHeaders, inputData) {
    var splitRegex = /\r\n|\r|\n/g;
    var table = config_1.Config.tableInstance();
    var settings = table.settings;
    var theme = config_1.getTheme(settings.theme);
    // Header row and columns
    var headerRow = new models_1.Row(inputHeaders, -1);
    headerRow.index = -1;
    // Columns and header row
    inputHeaders.forEach(function (rawColumn, index) {
        var dataKey = index;
        if (typeof rawColumn.dataKey !== 'undefined') {
            dataKey = rawColumn.dataKey;
        }
        else if (typeof rawColumn.key !== 'undefined') {
            console.error("Deprecation warning: Use dataKey instead of key");
            dataKey = rawColumn.key; // deprecated since 2.x
        }
        var col = new models_1.Column(dataKey, index);
        col.raw = rawColumn;
        col.widthStyle = config_1.Config.styles([theme.table, theme.header, table.styles.styles, table.styles.columnStyles[col.dataKey] || {}]).columnWidth;
        table.columns.push(col);
        var cell = new models_1.Cell(rawColumn);
        cell.styles = config_1.Config.styles([theme.table, theme.header, table.styles.styles, table.styles.headerStyles]);
        if (cell.raw instanceof HTMLElement) {
            cell.text = (cell.raw.innerText || '').trim();
        }
        else {
            var text = typeof cell.raw === 'object' ? cell.raw.title : cell.raw;
            // Stringify 0 and false, but not undefined
            cell.text = typeof cell.raw !== 'undefined' ? '' + text : '';
        }
        cell.text = cell.text.split(splitRegex);
        headerRow.cells[dataKey] = cell;
        for (var _i = 0, _a = table.hooks.createdHeaderCell; _i < _a.length; _i++) {
            var hook = _a[_i];
            hook(cell, { cell: cell, column: col, row: headerRow, settings: settings });
        }
    });
    table.headerRow = headerRow;
    // Rows och cells
    inputData.forEach(function (rawRow, i) {
        var row = new models_1.Row(rawRow, i);
        var rowStyles = i % 2 === 0 ? assign({}, theme.alternateRow, table.styles.alternateRowStyles) : {};
        table.columns.forEach(function (column) {
            var cell = new models_1.Cell(rawRow[column.dataKey]);
            var colStyles = table.styles.columnStyles[column.dataKey] || {};
            cell.styles = config_1.Config.styles([theme.table, theme.body, table.styles.styles, table.styles.bodyStyles, rowStyles, colStyles]);
            if (cell.raw && cell.raw instanceof HTMLElement) {
                cell.text = (cell.raw.innerText || '').trim();
            }
            else {
                // Stringify 0 and false, but not undefined
                cell.text = typeof cell.raw !== 'undefined' ? '' + cell.raw : '';
            }
            cell.text = cell.text.split(splitRegex);
            row.cells[column.dataKey] = cell;
            for (var _i = 0, _a = table.hooks.createdCell; _i < _a.length; _i++) {
                var hook = _a[_i];
                hook(cell, config_1.Config.hooksData({ cell: cell, column: column, row: row }));
            }
        });
        table.rows.push(row);
    });
}
exports.createModels = createModels;


/***/ })
/******/ ]);
});

/***/ }),

/***/ 718:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('span', {
    staticClass: "caption"
  }, [_vm._v("Download as ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "caption",
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.download('PDF')
      }
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('v-btn', {
    staticClass: "caption",
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.download('CSV')
      }
    }
  }, [_vm._v("CSV")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(720), __esModule: true };

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(359);
__webpack_require__(722);
module.exports = __webpack_require__(31).Array.from;


/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(71);
var createDesc = __webpack_require__(147);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(70);
var $export = __webpack_require__(55);
var toObject = __webpack_require__(146);
var call = __webpack_require__(356);
var isArrayIter = __webpack_require__(355);
var toLength = __webpack_require__(148);
var createProperty = __webpack_require__(721);
var getIterFn = __webpack_require__(358);

$export($export.S + $export.F * !__webpack_require__(357)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 735:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VDownloadAs_vue__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VDownloadAs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__VDownloadAs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_app_cfg__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_handy__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__utils_handy__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'v-download-as': __WEBPACK_IMPORTED_MODULE_5__VDownloadAs_vue___default.a
  },
  data: function data() {
    return {
      lAction: '',
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      handy: __WEBPACK_IMPORTED_MODULE_7__utils_handy___default.a,
      // rules: handy.rules,
      beingSaved: false,
      emp: [{ text: 'Name', value: 'emp_name' }, { text: 'Employee Id', value: 'vendor_emp_id' }, { text: 'Phone', value: 'emp_phone' }, { text: 'Designation', value: 'emp_desig' }, { text: 'Active Project', value: 'act_proj_list', width: '200px' }, { text: 'Completed Project', value: 'comp_proj_list', width: '200px' }, { text: 'Status', value: 'emp_status' }],
      allColumnsHeader: [{ text: 'Name', value: 'emp_name', width: '101px' }, { text: 'Employee Id', value: 'vendor_emp_id', width: '140px' }, { text: 'Phone', value: 'emp_phone', sortable: false }, { text: 'Designation', value: 'emp_desig', width: '120px', sortable: false }, { text: 'Active Project', value: 'act_proj_list', sortable: false }, { text: 'Completed Project', value: 'comp_proj_list', sortable: false }, { text: 'Email', value: 'emp_email', sortable: false }, { text: 'Address', value: 'emp_adr', sortable: false }, { text: 'City', value: 'city', sortable: false }, { text: 'PIN', value: 'pin_code', sortable: false }, { text: 'Emergency Contact', value: 'emergency_contact', sortable: false }, { text: 'Emergency Phone', value: 'emergency_phone', sortable: false }, { text: 'Blood Group', value: 'blood_group', sortable: false }, { text: 'Known Health Issue', value: 'known_health_issue', width: '110px', sortable: false }, { text: 'Date Of Birth', value: 'date_of_birth', sortable: false, width: '100px' }, { text: 'Date Of Joining', value: 'date_of_joining', sortable: false, width: '100px' }, { text: 'Experience', value: 'years_exp', sortable: false }, { text: 'Gender', value: 'gender', width: '150px', sortable: false }, { text: 'AADHAAR Number', value: 'aadhar_no', sortable: false }, { text: 'Marital Status', value: 'marital_status', sortable: false }, { text: 'Officical Number', value: 'official_number', sortable: false }, { text: 'ID Verified?', value: 'is_id_verified', sortable: false }, { text: 'Address Verifiled?', value: 'is_address_verified', sortable: false }, { text: 'Police Verified?', value: 'is_police_verif_done', sortable: false }, { text: 'Is PF Opted?', value: 'is_pf_opted', sortable: false }, { text: 'PF No', value: 'pf_no', width: '150px', sortable: false }, { text: 'UAN No', value: 'uan', width: '150px', sortable: false }, { text: 'Is ESI Opted?', value: 'is_esi_opted', sortable: false }, { text: 'ESI No', value: 'esi_no', sortable: false }, { text: 'Is GMC Opted?', value: 'is_gmc_opted', sortable: false }, { text: 'GMC No', value: 'gmc_no', sortable: false }, { text: 'Is GPA Opted?', value: 'is_gpa_opted', sortable: false }, { text: 'GPA No', value: 'gpa_no', sortable: false }, { text: 'Sub Vendor Emp?', value: 'is_sub_vendor_emp', sortable: false, width: '100px' }, { text: 'PAN No', value: 'pan', sortable: false }, { text: 'Bank Account No', value: 'bank_acc_no_for_exp', sortable: false }, { text: 'Bank IFSC Code', value: 'bank_ifsc_code', sortable: false }, { text: 'Bank Name', value: 'bank_name', sortable: false }, { text: 'Bank Branch Name', value: 'bank_branch_name', sortable: false }, { text: 'Payroll Category', value: 'payrol_cat', sortable: false }, { text: 'Relieving Date', value: 'date_of_relieved', sortable: false }, { text: 'Relieving Reason', value: 'status_reason', sortable: false }, { text: 'Last Working Date', value: 'last_working_date', sortable: false, width: '130px' }, { text: 'Last Updated On', value: 'last_updated_on', sortable: false, width: '100px' }, { text: 'Status', value: 'emp_status', sortable: false }],
      empSm: [{ text: 'Name', value: 'emp_name' }, { text: 'Employee Id', value: 'vendor_emp_id' }, { text: 'Status', value: 'emp_status' }],
      dupEmp: [{ text: 'Name', value: 'emp_name' }, { text: 'Employee Id', value: 'vendor_emp_id' }, { text: 'AADHAR No.', value: 'aadhar_no' }, { text: 'Active Project', value: 'act_proj_list' }],
      empList: [],
      lEmp: {},
      curEmp: {},
      previousData: {},
      lEmpTimeline: {},
      showTimeline: false,
      nextEmpEdited: false,
      dupEmpList: [],
      isDupEmp: false,
      dupOverride: false,
      empDesig: [],
      empRole: [],
      userid: [],
      dlgDt: false,
      dlgjoinDt: false,
      dlgReliveDt: false,
      dlglastworkingDt: false,
      dlgLastUpdateDateFrom: false,
      dlgLastUpdatedToDate: false,
      subVendorList: [],
      vendor_id: 1,
      comm_id: __WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.COMM_ID,
      empType: 'oe',
      lSearch: {},
      // emp Documents
      empHeader: [{ text: 'Document', value: 'emp_doc_type' }, { text: 'File', value: 'file_url' }, { text: '', value: '', width: '40px' }],
      empDocTypeId: null,
      lEmpDetails: [],
      // insert/update/delete doc type
      showDocType: false,
      lDocType: {},
      showInsertUpdateDocType: false,
      lDAction: '',
      docTypeHeader: [{ text: 'Document', value: 'emp_doc_type' }],
      empDocTypes: [],
      dlgFromDate: false,
      dlgToDate: false,
      dlgLastWorkFromDate: false,
      dlgLastWorkToDate: false,
      showAllColumns: false,
      dlgIdVerifyDt: false,
      dlgAddressVerifyDt: false,
      dlgPoliceVerifyDt: false,
      // family details
      empFamilyHeader: [{ text: 'Sr No.', value: '' }, { text: 'Name of the Family Members', value: 'family_name', width: '126px' }, { text: 'Relationship with Employee', value: 'relation_with_emp', width: '126px' }, { text: 'Date of Birth', value: 'dob', width: '120px' }, { text: 'Residing with Him/Her', value: 'residing_with_him', width: '126px' }, { text: 'Contact Number', value: 'contact_number' }, { text: 'Nominee', value: 'nominee' }],
      lEmpFamilyDetails: [],
      EmpFamilyDetailsList: [],
      showEmpFamilyDetList: false,
      dlgFamilyBDt: false,
      // Employee upload
      validateInProgress: true,
      readyForLoad: false,
      loadInProgress: true,
      validFile: true,
      headerIssue: false,
      fileError: false,
      totRecs: 0,
      recsLoaded: [],
      totValid: 0,
      totInvalid: 0,
      totLoaded: 0,
      totFail: 0,
      reqHeaders: ['Emp ID', 'Emp Name', 'PF Number', 'UAN No.', 'ESI No.', 'GMC No.', 'GPA No.', 'Bank Acc No.', 'Bank IFSC Code'],
      colNames: [{ col_name: 'vendor_emp_id', is_required: true }, { col_name: 'emp_name', is_required: true }, { col_name: 'pf_no', is_required: false }, { col_name: 'uan', is_required: false }, { col_name: 'esi_no', is_required: false }, { col_name: 'gmc_no', is_required: false }, { col_name: 'gpa_no', is_required: false }, { col_name: 'bank_acc_no', is_required: false }, { col_name: 'bank_ifsc_code', is_required: false }],
      loadHeadSm: [{ text: 'Emp ID', value: 'vendor_emp_id' }, { text: 'Emp Name', value: 'emp_name' }, { text: 'PF Number', value: 'pf_no' }, { text: 'UAN No.', value: 'uan' }, { text: 'ESI No.', value: 'esi_no' }, { text: 'GMC No.', value: 'gmc_no' }, { text: 'GPA No.', value: 'gpa_no' }, { text: 'Bank Acc No.', value: 'bank_acc_no' }, { text: 'Bank IFSC Code', value: 'bank_ifsc_code' }],
      comm_vendor_id: '1',
      undeployed_on: null,
      // is_billable: 'true',
      // deployed_on: this.date_of_joining,
      birthDate: '',
      years: null,
      months: null,
      days: null,
      roleList: [],
      projId: [],
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        }
      },
      disableSubmitButton: false,
      isFileAdded: false,
      isAdmin: __WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.IS_ADMIN
    };
  },
  mounted: function mounted() {
    this.lAction = 'view';
    // load available doc types
    this.loadMasterDocTypes();
    this.loadProjectId();
  },

  methods: {
    msg: function msg(m) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (type === 0) {
        this.sbarCol = 'error';
      } else if (type === 1) {
        this.sbarCol = 'success';
      } else {
        this.sbarCol = 'info';
      }
      this.sbar = true;
      this.sbarMsg = m;
    },
    searchEmployee: function searchEmployee() {
      var _this = this;

      if (!this.lSearch.emp_name && !this.lSearch.vendor_emp_id && !this.lSearch.aadhar_no && !this.lSearch.emp_desig && !this.lSearch.proj_name && !this.lSearch.emp_status && !this.lSearch.emp_with_project && !this.lSearch.emp_with_no_project && (!this.lSearch.verification_list || !this.lSearch.verification_list.length) && (!this.lSearch.doc_list || !this.lSearch.doc_list.length) && !this.lSearch.emp_with_multiple_project && !this.lSearch.date_of_joining_from_dt && !this.lSearch.date_of_joining_to_dt && !this.lSearch.last_working_date_from && !this.lSearch.last_working_date_till && !this.lSearch.last_Updated_date_from && !this.lSearch.last_Updated_date_till) {
        this.msg('Please enter any search criteria', 0);
        return;
      } else if (this.lSearch.date_of_joining_from_dt && !this.lSearch.date_of_joining_to_dt) {
        this.lSearch.date_of_joining_to_dt = this.lSearch.date_of_joining_from_dt;
      } else if (this.lSearch.last_working_date_from && !this.lSearch.last_working_date_till) {
        this.lSearch.last_working_date_till = this.lSearch.last_working_date_from;
      } else if (this.lSearch.last_Updated_date_from && !this.lSearch.last_Updated_date_till) {
        this.lSearch.last_Updated_date_till = this.lSearch.last_Updated_date_from;
      }
      var qry = {
        params: {}
      };
      qry.params = this.lSearch;
      qry.params.vendor_id = this.vendor_id;
      this.beingSaved = true;
      this.axios.get(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.API_URL + '/searchEmployee/', qry).then(function (response) {
        _this.empList = response.data;
        if (!_this.empList.length) {
          _this.msg('No records found for given search criteria', 0);
        }
        _this.lAction = 'view';
        _this.beingSaved = false;
      }).catch(function (err) {
        _this.msg(err);
        _this.empList = [];
        _this.beingSaved = false;
      });
    },
    getEmptyEmp: function getEmptyEmp() {
      var emptyEmp = {
        vendor_id: 1,
        empType: 'oe',
        emp_name: '',
        emp_desig_pair: '',
        emp_role_pair: '',
        years_exp: null,
        city: '',
        date_of_birth: '',
        date_of_joining: '',
        gender: '',
        emp_status: 'On Job',
        emp_phone: 0,
        last_working_date: '',
        status_reason: '',
        is_pf_opted: 0,
        pf_no: '',
        is_esi_opted: 0,
        esi_no: '',
        is_gmc_opted: 0,
        gmc_no: '',
        is_gpa_opted: 0,
        gpa_no: '',
        payroll_cat: 'REGULAR',
        is_id_verified: false,
        is_address_verified: false,
        is_police_verif_done: false,
        is_bg_verify_require: false,
        id_verified_date: null,
        address_verified_date: null,
        police_verif_date: null,
        is_pan_available: 0,
        uan: '',
        official_number: '',
        marital_status: '',
        is_professional_fee_opted: false,
        professional_fee: ''
      };
      return emptyEmp;
    },
    prepareCreate: function prepareCreate() {
      this.lEmp = this.getEmptyEmp();
      this.dupOverride = false;
      this.isDupEmp = false;
      // next emp id
      this.loadNextEmpId();
      this.lAction = 'create';
      this.loadDocType();
      this.loadRoles();
      this.loadDesignation();
    },
    loadNextEmpId: function loadNextEmpId() {
      var _this2 = this;

      var qry = {
        params: {
          vendor_id: this.vendor_id
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.API_URL + '/getNextEmpId/', qry).then(function (response) {
        _this2.lEmp.next_vendor_emp_id = response.data;
        _this2.$forceUpdate();
      }).catch(function (err) {
        _this2.msg(err.response.data);
      });
    },
    loadDesignation: function loadDesignation() {
      var _this3 = this;

      var qry = {
        params: {
          vendor_id: this.vendor_id
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.API_URL + '/getEmpDesigByVendorId/', qry).then(function (response) {
        _this3.empDesig = response.data;
      }).catch(function (err) {
        _this3.msg(err.response.data);
      });
    },
    loadDocType: function loadDocType() {
      var _this4 = this;

      var empId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var qry = {
        params: {
          vendor_id: this.vendor_id,
          emp_id: empId
        }
      };
      this.lEmpDetails = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.API_URL + '/getDocumentTypeBasedonVendorId/', qry).then(function (response) {
        if (_this4.lAction === 'create') {
          response.data.forEach(function (rec) {
            _this4.lEmpDetails.push({
              emp_doc_type_id: rec.emp_doc_type_id,
              emp_doc_type: rec.emp_doc_type,
              vendor_id: _this4.vendor_id,
              files: []
            });
          });
        } else {
          response.data.forEach(function (rec) {
            _this4.lEmpDetails.push({
              emp_doc_type_id: rec.emp_doc_type_id,
              emp_doc_type: rec.emp_doc_type,
              vendor_id: _this4.vendor_id,
              file_url: rec.file_url,
              files: []
            });
          });
          var path = __webpack_require__(354);
          var files = '';
          _this4.lEmpDetails.forEach(function (rec) {
            files = '';
            if (rec.file_url) {
              files = rec.file_url.split(',');
              if (files.length > 0) {
                files.forEach(function (file) {
                  rec.files.push({
                    file_url: file,
                    file_name: file ? path.basename(file) : '',
                    is_selected: true,
                    is_changes: false
                  });
                });
              }
            }
          });
        }
        _this4.$forceUpdate();
      }).catch(function (err) {
        _this4.msg(err);
      });
    },
    loadMasterDocTypes: function loadMasterDocTypes() {
      var _this5 = this;

      var qry = {
        params: {
          vendor_id: this.vendor_id
        }
      };
      this.empDocTypes = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.API_URL + '/getDocumentTypeBasedonVendorId/', qry).then(function (response) {
        _this5.empDocTypes = response.data;
      }).catch(function (err) {
        _this5.msg(err);
      });
    },
    prepareEditEmp: function prepareEditEmp(curEmp) {
      this.lEmp = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, curEmp);
      this.lEmpDetails = [];
      this.lEmp.changed_emp_id = this.lEmp.vendor_emp_id;
      this.lEmp.emp_desig_pair = { emp_desig_id: this.lEmp.emp_desig_id, emp_desig: this.lEmp.emp_desig };
      this.lEmp.staff_role_pair = { staff_role_id: this.lEmp.staff_role_id, staff_role: this.lEmp.staff_role };
      this.lEmp.date_of_birth = this.lEmp.date_of_birth ? __WEBPACK_IMPORTED_MODULE_7__utils_handy___default.a.formatDBDate(this.lEmp.date_of_birth) : null;
      this.lEmp.date_of_joining = this.lEmp.date_of_joining ? __WEBPACK_IMPORTED_MODULE_7__utils_handy___default.a.formatDBDate(this.lEmp.date_of_joining) : null;
      this.lEmp.last_working_date = this.lEmp.last_working_date ? __WEBPACK_IMPORTED_MODULE_7__utils_handy___default.a.formatDBDate(this.lEmp.last_working_date) : null;
      this.lEmp.id_verified_date = this.lEmp.id_verified_date ? __WEBPACK_IMPORTED_MODULE_7__utils_handy___default.a.formatDBDate(this.lEmp.id_verified_date) : null;
      this.lEmp.address_verified_date = this.lEmp.address_verified_date ? __WEBPACK_IMPORTED_MODULE_7__utils_handy___default.a.formatDBDate(this.lEmp.address_verified_date) : null;
      this.lEmp.police_verif_date = this.lEmp.police_verif_date ? __WEBPACK_IMPORTED_MODULE_7__utils_handy___default.a.formatDBDate(this.lEmp.police_verif_date) : null;
      this.lEmp.uan = this.lEmp.uan ? this.lEmp.uan : '';
      this.lEmp.official_number = this.lEmp.official_number ? this.lEmp.official_number : '';
      this.empType = this.lEmp.is_sub_vendor_emp ? 'subvendor' : 'oe';
      this.isDupEmp = false;
      this.dupOverride = false;
      this.previousData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.lEmp); // if there are any changes while updating at that time this will use to make Employee detail notes
      this.lAction = 'update';
      this.loadRoles();
      this.loadDesignation();
      this.loadDocType(curEmp.emp_id);
    },
    saveEmployee: function saveEmployee(action) {
      var _this6 = this;

      // validate and save Changes
      if (!this.$refs.eForm.validate()) {
        return;
      }
      if (this.lEmp.official_number && this.lEmp.official_number.length < 10) {
        this.msg('Official number should be of 10 number', 0);
        return;
      }
      // preparation
      this.lEmp.emp_desig_id = this.lEmp.emp_desig_pair.emp_desig_id;
      this.lEmp.emp_desig = this.lEmp.emp_desig_pair.emp_desig;
      // remove prefix and suffix space
      this.lEmp.emp_name = this.lEmp.emp_name ? this.lEmp.emp_name.trim() : '';
      // this.lEmp.years_exp = this.lEmp.years_exp.split(" ").join("") ? this.lEmp.years_exp.replace(/\s/g, '') : null
      this.lEmp.aadhar_no = this.lEmp.aadhar_no ? this.lEmp.aadhar_no.trim() : '';
      this.lEmp.official_number = this.lEmp.official_number ? this.lEmp.official_number.trim() : '';
      this.lEmp.emp_adr = this.lEmp.emp_adr ? this.lEmp.emp_adr.trim() : '';
      this.lEmp.city = this.lEmp.city ? this.lEmp.city.trim() : '';
      this.lEmp.pin_code = this.lEmp.pin_code ? this.lEmp.pin_code.trim() : '';
      this.lEmp.emp_phone = this.lEmp.emp_phone ? this.lEmp.emp_phone.trim() : '0';
      this.lEmp.emp_email = this.lEmp.emp_email ? this.lEmp.emp_email.trim() : '';
      this.lEmp.emergency_contact = this.lEmp.emergency_contact ? this.lEmp.emergency_contact.trim() : '';
      this.lEmp.emergency_phone = this.lEmp.emergency_phone ? this.lEmp.emergency_phone.trim() : '';
      this.lEmp.blood_group = this.lEmp.blood_group ? this.lEmp.blood_group.trim() : '';
      this.lEmp.known_health_issue = this.lEmp.known_health_issue ? this.lEmp.known_health_issue.trim() : '';
      this.lEmp.bank_acc_no = this.lEmp.bank_acc_no ? this.lEmp.bank_acc_no.trim() : '';
      this.lEmp.bank_ifsc_code = this.lEmp.bank_ifsc_code ? this.lEmp.bank_ifsc_code.trim() : '';
      this.lEmp.bank_name = this.lEmp.bank_name ? this.lEmp.bank_name.trim() : '';
      this.lEmp.bank_branch_name = this.lEmp.bank_branch_name ? this.lEmp.bank_branch_name.trim() : '';
      this.beingSaved = true;
      this.lEmp.notes = '';
      if (action === 'update') {
        if (this.previousData.emp_name !== this.lEmp.emp_name) {
          this.lEmp.notes += ' Employee Name from "' + this.previousData.emp_name + '" to "' + this.lEmp.emp_name + '",';
        }
        if (this.previousData.emp_desig_pair.emp_desig_id !== this.lEmp.emp_desig_pair.emp_desig_id) {
          this.lEmp.notes += ' Designation from "' + this.previousData.emp_desig_pair.emp_desig + '" to "' + this.lEmp.emp_desig_pair.emp_desig + '",';
        }
        if (this.previousData.gender !== this.lEmp.gender) {
          this.lEmp.notes += ' Gender from "' + this.previousData.gender + '" to "' + this.lEmp.gender + '",';
        }
        if (this.previousData.date_of_joining !== this.lEmp.date_of_joining) {
          this.lEmp.notes += ' Date of Joining from "' + this.previousData.date_of_joining + '" to "' + this.lEmp.date_of_joining + '",';
        }
        if (this.previousData.years_exp !== this.lEmp.years_exp) {
          this.lEmp.notes += ' Years of Experience from "' + this.previousData.years_exp + '" to "' + this.lEmp.years_exp + '",';
        }
        if (this.previousData.date_of_birth !== this.lEmp.date_of_birth) {
          this.lEmp.notes += ' Date of Birth from "' + this.previousData.date_of_birth + '" to "' + this.lEmp.date_of_birth + '",';
        }
        if (this.previousData.aadhar_no !== this.lEmp.aadhar_no) {
          this.lEmp.notes += ' Aadhar no from "' + this.previousData.aadhar_no + '" to "' + this.lEmp.aadhar_no + '",';
        }
        if (this.previousData.marital_status !== this.lEmp.marital_status) {
          this.lEmp.notes += ' Marital Status from "' + this.previousData.marital_status + '" to "' + this.lEmp.marital_status + '",';
        }
        if (this.previousData.official_number !== this.lEmp.official_number) {
          this.lEmp.notes += ' Official no from "' + this.previousData.official_number + '" to "' + this.lEmp.official_number + '",';
        }
        if (this.previousData.emp_status !== this.lEmp.emp_status) {
          this.lEmp.notes += ' Employee Status from "' + this.previousData.emp_status + '" to "' + this.lEmp.emp_status + '",';
        }
        if (this.previousData.status_reason !== this.lEmp.status_reason) {
          this.lEmp.notes += ' Relieving Reason from "' + this.previousData.status_reason + '" to "' + this.lEmp.status_reason + '",';
        }
        if (this.previousData.last_working_date !== this.lEmp.last_working_date) {
          this.lEmp.notes += ' Last Working Date from "' + this.previousData.last_working_date + '" to "' + this.lEmp.last_working_date + '",';
        }
        if (this.previousData.emp_adr !== this.lEmp.emp_adr) {
          this.lEmp.notes += ' Address from "' + this.previousData.emp_adr + '" to "' + this.lEmp.emp_adr + '",';
        }
        if (this.previousData.city !== this.lEmp.city) {
          this.lEmp.notes += ' City from "' + this.previousData.city + '" to "' + this.lEmp.city + '",';
        }
        if (this.previousData.pin_code !== this.lEmp.pin_code) {
          this.lEmp.notes += ' PIN Code from "' + this.previousData.pin_code + '" to "' + this.lEmp.pin_code + '",';
        }
        if (this.previousData.emp_phone !== this.lEmp.emp_phone) {
          this.lEmp.notes += ' Phone no from "' + this.previousData.emp_phone + '" to "' + this.lEmp.emp_phone + '",';
        }
        if (this.previousData.emp_email !== this.lEmp.emp_email) {
          this.lEmp.notes += ' Email from "' + this.previousData.emp_email + '" to "' + this.lEmp.emp_email + '",';
        }
        if (this.previousData.emergency_contact !== this.lEmp.emergency_contact) {
          this.lEmp.notes += ' Emergency Contact Person from "' + this.previousData.emergency_contact + '" to "' + this.lEmp.emergency_contact + '",';
        }
        if (this.previousData.emergency_phone !== this.lEmp.emergency_phone) {
          this.lEmp.notes += ' Emergency Phone from "' + this.previousData.emergency_phone + '" to "' + this.lEmp.emergency_phone + '",';
        }
        if (this.previousData.blood_group !== this.lEmp.blood_group) {
          this.lEmp.notes += ' Blood Group from "' + this.previousData.blood_group + '" to "' + this.lEmp.blood_group + '",';
        }
        if (this.previousData.known_health_issue !== this.lEmp.known_health_issue) {
          this.lEmp.notes += ' Health Issus Known from "' + this.previousData.known_health_issue + '" to "' + this.lEmp.known_health_issue + '",';
        }
        if (this.previousData.payroll_cat !== this.lEmp.payroll_cat) {
          this.lEmp.notes += ' Payroll Category from "' + this.previousData.payroll_cat + '" to "' + this.lEmp.payroll_cat + '",';
        }
        if (this.previousData.is_pan_available !== this.lEmp.is_pan_available) {
          this.lEmp.notes += ' Is PAN Opted? from "' + this.previousData.is_pan_available + '" to "' + this.lEmp.is_pan_available + '",';
        }
        if (this.previousData.pan !== this.lEmp.pan) {
          this.lEmp.notes += ' PAN from "' + this.previousData.pan + '" to "' + this.lEmp.pan + '",';
        }
        if (this.previousData.is_pf_opted !== this.lEmp.is_pf_opted) {
          this.lEmp.notes += ' Is PF Opted? from "' + this.previousData.is_pf_opted + '" to "' + this.lEmp.is_pf_opted + '",';
        }
        if (this.previousData.pf_no !== this.lEmp.pf_no) {
          this.lEmp.notes += ' PF No from "' + this.previousData.pf_no + '" to "' + this.lEmp.pf_no + '",';
        }
        if (this.previousData.uan !== this.lEmp.uan) {
          this.lEmp.notes += ' UAN from "' + this.previousData.uan + '" to "' + this.lEmp.uan + '",';
        }
        if (this.previousData.is_esi_opted !== this.lEmp.is_esi_opted) {
          this.lEmp.notes += ' Is ESI Opted? from "' + this.previousData.is_esi_opted + '" to "' + this.lEmp.is_esi_opted + '",';
        }
        if (this.previousData.esi_no !== this.lEmp.esi_no) {
          this.lEmp.notes += ' ESI No from "' + this.previousData.esi_no + '" to "' + this.lEmp.esi_no + '",';
        }
        if (this.previousData.bank_acc_no !== this.lEmp.bank_acc_no) {
          this.lEmp.notes += ' Bank Account No from "' + this.previousData.bank_acc_no + '" to "' + this.lEmp.bank_acc_no + '",';
        }
        if (this.previousData.bank_ifsc_code !== this.lEmp.bank_ifsc_code) {
          this.lEmp.notes += ' Bank IFSC Code No from "' + this.previousData.bank_ifsc_code + '" to "' + this.lEmp.bank_ifsc_code + '",';
        }
        if (this.previousData.bank_name !== this.lEmp.bank_name) {
          this.lEmp.notes += ' Bank Name from "' + this.previousData.bank_name + '" to "' + this.lEmp.bank_name + '",';
        }
        if (this.previousData.bank_branch_name !== this.lEmp.bank_branch_name) {
          this.lEmp.notes += ' Bank Branch Name from "' + this.previousData.bank_branch_name + '" to "' + this.lEmp.bank_branch_name + '",';
        }
      }
      this.lEmp.action_by = __WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.USER_ID;

      // check for closely matching existing employees to avoid duplication
      var qry = {
        params: {}
      };
      qry.params = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.lEmp);
      qry.params.vendor_id = this.vendor_id;
      this.beingSaved = true;
      this.axios.get(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.API_URL + '/searchDupEmployee/', qry).then(function (response) {
        if (response.data.length && !_this6.dupOverride) {
          if (action === 'create') {
            _this6.isDupEmp = true;
            _this6.dupEmpList = response.data;
          } else {
            // exclude employee being edited from duplicate check
            _this6.dupEmpList = response.data.filter(function (rec) {
              return rec.emp_id !== _this6.lEmp.emp_id;
            });
            _this6.isDupEmp = _this6.dupEmpList.length > 0;
          }
          _this6.dupOverride = false;
        } else {
          _this6.isDupEmp = false;
        }
        if (!_this6.isDupEmp) {
          _this6.lEmp.details = _this6.lEmpDetails;
          _this6.axios.post(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.API_URL + '/employee/' + action, _this6.lEmp).then(function (response) {
            // commit the changes in front end as well
            if (action === 'update') {
              var idx = _this6.empList.findIndex(function (rec) {
                return rec.emp_id === _this6.lEmp.emp_id;
              });
              __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(_this6.empList[idx], _this6.lEmp);
            } else {
              _this6.lEmp.emp_id = response.data[0];
            }
            _this6.msg('Saved successfully', 1);
            _this6.lAction = 'view';
            _this6.beingSaved = false;
          }).catch(function (err) {
            _this6.msg(err.response.data);
            _this6.beingSaved = false;
          });
        } else {
          _this6.beingSaved = false;
        }
      });
    },
    cancelChanges: function cancelChanges() {
      this.beingSaved = false;
      this.lAction = 'view';
    },
    deleteEmp: function deleteEmp() {
      var _this7 = this;

      if (!confirm('Sure, you want to delete the Employee with name "' + this.lEmp.emp_name + '"?')) {
        return;
      }
      // delete employee
      this.axios.post(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.API_URL + '/employee/delete', this.lEmp).then(function (response) {
        // commit the changes in front end as well
        var idx = _this7.empList.findIndex(function (rec) {
          return rec.emp_id === _this7.lEmp.emp_id;
        });
        _this7.empList.splice(idx, 1);
        _this7.msg('Deleted successfully', 1);
        _this7.lAction = 'view';
        _this7.beingSaved = false;
      }).catch(function (err) {
        _this7.msg(err.response.data);
        _this7.beingSaved = false;
      });
    },
    clear: function clear() {
      this.$refs.sForm.reset();
      this.empList.length = [];
      this.showAllColumns = false;
    },
    pickFile: function pickFile(curId) {
      this.empDocTypeId = curId;
      this.$refs.fileInput.click();
    },
    loadFilesFromFileBrowser: function loadFilesFromFileBrowser() {
      var _this8 = this;

      var idx = this.lEmpDetails.findIndex(function (rec) {
        return rec.emp_doc_type_id === _this8.empDocTypeId;
      });
      var files = event.target.files;
      if (files.length > 0) {
        this.isFileAdded = true;
      } else {
        this.isFileAdded = false;
      }
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(files).forEach(function (file) {
        var fileReader = new FileReader();
        var getResult = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
          fileReader.onload = function (e) {
            _this8.lEmpDetails[idx].files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name,
              is_selected: true,
              is_changed: true
            });
            _this8.$forceUpdate();
          };
        });
        fileReader.readAsDataURL(file);
        return getResult.then(function (file) {
          return file;
        });
      });
    },
    showDocTypeList: function showDocTypeList() {
      this.loadDocType();
      this.lDAction = 'view';
      this.showDocType = true;
    },
    prepareCreateDocType: function prepareCreateDocType() {
      this.lDocType = {
        emp_doc_type: '',
        vendor_id: this.vendor_id
      };
      this.lDAction = 'create';
      this.showInsertUpdateDocType = true;
    },
    prepareUpdateDocType: function prepareUpdateDocType(curDocType) {
      this.lDocType = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, curDocType);
      this.lDAction = 'update';
      this.showInsertUpdateDocType = true;
    },
    saveDocTypeChange: function saveDocTypeChange(action) {
      var _this9 = this;

      if (action === 'delete-doctype') {
        if (!confirm('Sure, you want to delete the Doc Type with name "' + this.lDocType.emp_doc_type + '"?')) {
          return;
        }
      }
      this.axios.post(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.API_URL + '/employee/' + action, this.lDocType).then(function (response) {
        // commit the changes in front end as well
        _this9.loadDocType();
        _this9.showInsertUpdateDocType = false;
      }).catch(function (err) {
        _this9.msg(err.response.data);
        _this9.beingSaved = false;
      });
    },
    promptUpload: function promptUpload() {
      this.$refs.ipFile.click();
    },
    prepareEmpTimeline: function prepareEmpTimeline() {
      var _this10 = this;

      var qry = {
        params: {
          emp_id: this.lEmp.emp_id
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.API_URL + '/getEmpDetailsAsTimeline/', qry).then(function (response) {
        _this10.lEmpTimeline = response.data;
        var timeLineNote = [];
        timeLineNote = response.data.filter(function (rec) {
          return rec.notes !== null;
        });
        if (timeLineNote) {
          var note = '';
          var cidx = 0;
          for (var k = 0; k < timeLineNote.length; k++) {
            cidx = response.data.findIndex(function (rec) {
              return rec.emp_det_id === timeLineNote[k].emp_det_id;
            });
            note = timeLineNote[k].notes.split(',');
            _this10.lEmpTimeline[cidx].timeLineNote = [];
            for (var i = 0; i < note.length; i++) {
              _this10.lEmpTimeline[cidx].timeLineNote[i] = note[i];
            }
          }
        }
        _this10.showTimeline = true;
      }).catch(function (err) {
        _this10.msg(err, 0);
      });
    },
    prepareUpload: function prepareUpload() {
      this.lAction = 'upload';
    },
    validateFile: function validateFile() {
      var _this11 = this;

      this.lAction = 'validate';
      this.validateInProgress = true;
      this.loadInProgress = true;
      this.validFile = true;
      this.headerIssue = false;
      this.fileError = false;
      this.totRecs = 0;
      this.recsLoaded = [];
      this.totValid = 0;
      this.totInvalid = 0;
      this.totLoaded = 0;
      this.totFail = 0;
      // read file
      var file = this.$refs.ipFile.files[0];
      var reader = new FileReader();
      reader.onload = function (e) {
        var content = e.target.result;
        // validate & show result
        var allLines = content.split(/\r\n|\n/);
        // ignore empty lines if any
        allLines = allLines.filter(function (rec) {
          return !rec.startsWith(',,,,');
        });
        _this11.totRecs = allLines.length - 1;
        var headers = allLines[0].split(',');
        // 1. header & required columns
        for (var i = 0; i < _this11.reqHeaders.length; i++) {
          if (headers[i] !== _this11.reqHeaders[i]) {
            _this11.validateInProgress = false;
            _this11.validFile = false;
            _this11.headerIssue = true;
            return;
          }
        }
        // 2. validate each record
        var res = {};
        var curRec = [];
        for (var j = 1; j < allLines.length; j++) {
          if (allLines[j]) {
            curRec = allLines[j].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
            res = { 'error': '' };
            for (var c = 0; c < _this11.colNames.length; c++) {
              if (_this11.colNames[c].is_required && curRec[c].trim() === '') {
                // special validation
                res['error'] += _this11.reqHeaders[c] + ' is empty; ';
              } else {
                res[_this11.colNames[c].col_name] = curRec[c] && curRec[c].indexOf('"') >= 0 ? curRec[c].split('"').join('') : curRec[c];
              }
              if (res['asset_value'] === '') {
                res['asset_value'] = null;
              }
            }
            _this11.recsLoaded.push(res);
            if (res['error']) {
              _this11.totInvalid++;
            } else {
              _this11.totValid++;
            }
          }
        }
        if (_this11.totInvalid) {
          _this11.validFile = false;
        }
        _this11.validateInProgress = false;
      };
      reader.readAsText(file);
    },
    uploadEmployee: function uploadEmployee() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var curRec, i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // create asset List one by one
                _this12.readyForLoad = true;
                _this12.loadInProgress = true;
                _this12.beingSaved = true;
                curRec = '';
                // var tmpDt = null

                i = 0;

              case 5:
                if (!(i < _this12.recsLoaded.length)) {
                  _context.next = 21;
                  break;
                }

                curRec = _this12.recsLoaded[i];

                if (_this12.recsLoaded[i].error) {
                  _context.next = 18;
                  break;
                }

                // process only valid records
                // fill-in gaps
                if (!curRec.pf_no) {
                  curRec.pf_no = null;
                }
                if (!curRec.uan) {
                  curRec.uan = null;
                }
                if (!curRec.esi_no) {
                  curRec.esi_no = null;
                }
                if (!curRec.gmc_no) {
                  curRec.gmc_no = null;
                }
                if (!curRec.gpa_no) {
                  curRec.gpa_no = null;
                }
                if (!curRec.bank_acc_no) {
                  curRec.bank_acc_no = null;
                }
                if (!curRec.bank_ifsc_code) {
                  curRec.bank_ifsc_code = null;
                }
                // create record
                curRec.action_by = __WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.USER_ID;
                _context.next = 18;
                return _this12.axios.post(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.API_URL + '/bulkuploadofEmployee/', _this12.recsLoaded[i]).then(function (response) {
                  curRec.load_status = 'Loaded';
                  _this12.totLoaded++;
                }).catch(function (err) {
                  curRec.error = err.response.data;
                  curRec.load_status = 'Failed';
                  _this12.totFail++;
                });

              case 18:
                i++;
                _context.next = 5;
                break;

              case 21:
                // for every record
                if (!_this12.totFail) {
                  _this12.msg('Uploaded successfully', 1);
                  _this12.lAction = 'view';
                }
                _this12.loadInProgress = false;
                _this12.beingSaved = false;

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this12);
      }))();
    },
    showError: function showError(err) {
      this.msg(err, 0);
    },
    deployeIntoProject: function deployeIntoProject() {
      var _this13 = this;

      this.saveEmployee();
      this.lAction = 'create';
      // Deployee FM Created employee into Project
      this.curEmp.vendor_emp_id = this.lEmp.next_vendor_emp_id;
      this.curEmp.comm_id = __WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.COMM_ID;
      this.curEmp.comm_vendor_id = this.vendor_id;
      this.curEmp.deployed_on = this.lEmp.date_of_joining;
      this.curEmp.vendor_proj_id = this.projId.proj_id;
      this.curEmp.is_billable = true;
      this.curEmp.staff_role_id = this.lEmp.staff_role_pair.staff_role_id;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.API_URL + '/deployeIntoProject', this.curEmp).then(function (response) {
        _this13.msg('Deployed successfully', 1);
        _this13.lAction = 'view';
        _this13.beingSaved = false;
      }).catch(function (err) {
        _this13.msg(err.response.data);
        _this13.beingSaved = false;
      });
    },
    loadRoles: function loadRoles() {
      var _this14 = this;

      // load roles of this community
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.API_URL + '/getStaffRolesByCommIdforDeploye/', qry).then(function (response) {
        _this14.empRole = response.data;
      }).catch(function (err) {
        _this14.msg(err.response.data);
      });
    },
    loadProjectId: function loadProjectId() {
      var _this15 = this;

      // load Project Id of this community
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_6__config_app_cfg___default.a.API_URL + '/getProjIdByCommIdforDeploye/', qry).then(function (response) {
        _this15.projId = response.data;
      }).catch(function (err) {
        _this15.msg(err.response.data);
      });
    },
    calculateAge: function calculateAge(dofb) {
      if (!dofb) return;
      var currentDate = new Date();
      if (new Date(dofb) > currentDate) {
        this.birthDate = null;
        this.years = null;
        this.months = null;
        this.days = null;
        alert('Invalid Date of Birth');
      }
      var diffTime = currentDate - new Date(dofb);
      var totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      this.years = Math.floor(totalDays / 365.25);
      this.months = Math.floor(totalDays % 365.25 / 30.4375);
      this.days = Math.floor(totalDays % 365.25 % 30.4375);
      // this.lEmp.years_exp = this.years + ' Years, ' + this.months + ' Months, ' + this.days + ' Days'
      this.lEmp.years_exp = this.years;
    }
  }
});

/***/ }),

/***/ 772:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(712)(true);
// imports


// module
exports.push([module.i, ".my-label-text-size .v-label{font-size:14px!important}.v-alert{border-radius:5px;border-width:4px 0 0;border-style:solid;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:14px;margin:4px;padding:5px;position:relative}.v-text-field{padding-top:0;margin-top:4px}.container.grid-list-md .layout .flex{padding:1px}.v-card__title{display:-webkit-box;display:-ms-flexbox;display:flex;color:blue;padding:10px;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.my-notice{color:red;padding-left:20px;text-align:center;margin-left:40px;margin-right:40px;border-style:solid;font-size:18px;font-family:Tektur;font-weight:400}", "", {"version":3,"sources":["/var/www/html/uswebapp/src/components/Employee.vue"],"names":[],"mappings":"AACA,6BACE,wBAA2B,CAC5B,AACD,SACE,kBAAmB,AACnB,qBAAsB,AACtB,mBAAoB,AACpB,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,eAAgB,AAChB,WAAY,AACZ,YAAa,AACb,iBAAmB,CACpB,AACD,cACE,cAAiB,AACjB,cAAgB,CACjB,AACD,sCACE,WAAa,CACd,AACD,eACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,WAAY,AACZ,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,WACE,UAAW,AACX,kBAAmB,AACnB,kBAAmB,AACnB,iBAAkB,AAClB,kBAAmB,AACnB,mBAAoB,AACpB,eAAgB,AAChB,mBAAsB,AACtB,eAAkB,CACnB","file":"Employee.vue","sourcesContent":["\n.my-label-text-size .v-label {\n  font-size: 14px !important;\n}\n.v-alert {\n  border-radius: 5px;\n  border-width: 4px 0 0;\n  border-style: solid;\n  color: #fff;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 14px;\n  margin: 4px;\n  padding: 5px;\n  position: relative;\n}\n.v-text-field {\n  padding-top: 0px;\n  margin-top: 4px;\n}\n.container.grid-list-md .layout .flex {\n  padding: 1px;\n}\n.v-card__title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  color: Blue;\n  padding: 10px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.my-notice{\n  color:red ;\n  padding-left: 20px;\n  text-align: center;\n  margin-left: 40px;\n  margin-right: 40px;\n  border-style: solid;\n  font-size: 18px;\n  font-family: 'Tektur';\n  font-weight:normal\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(772);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(713)("9af32ce8", content, true, {});

/***/ }),

/***/ 796:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "py-0 padding-0",
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [(_vm.isAdmin !== true) ? _c('v-flex', [_c('div', [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Contact Admin")])])])]) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view' && _vm.isAdmin === true) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "mx-auto": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title primary--text pa-3"
  }, [_vm._v("\n        Search Employee\n      ")]), _vm._v(" "), _c('v-form', {
    ref: "sForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchEmployee()
      }
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mx-4": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Employee Name",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lSearch.emp_name),
      callback: function($$v) {
        _vm.$set(_vm.lSearch, "emp_name", $$v)
      },
      expression: "lSearch.emp_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Designation",
      "hide-details": "",
      "maxlength": "35"
    },
    model: {
      value: (_vm.lSearch.emp_desig),
      callback: function($$v) {
        _vm.$set(_vm.lSearch, "emp_desig", $$v)
      },
      expression: "lSearch.emp_desig"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Employee Id",
      "hide-details": "",
      "maxlength": "6"
    },
    model: {
      value: (_vm.lSearch.vendor_emp_id),
      callback: function($$v) {
        _vm.$set(_vm.lSearch, "vendor_emp_id", $$v)
      },
      expression: "lSearch.vendor_emp_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "AADHAR No.",
      "hide-details": "",
      "maxlength": "20"
    },
    model: {
      value: (_vm.lSearch.aadhar_no),
      callback: function($$v) {
        _vm.$set(_vm.lSearch, "aadhar_no", $$v)
      },
      expression: "lSearch.aadhar_no"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("search")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view' && _vm.empList.length > 0) ? _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": "",
      "grid-list-md": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-flex', {
    staticClass: "title primary--text pa-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', [_vm._v("Search Result (" + _vm._s(_vm.empList.length) + " Records)")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Show all columns"
    },
    model: {
      value: (_vm.showAllColumns),
      callback: function($$v) {
        _vm.showAllColumns = $$v
      },
      expression: "showAllColumns"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.showAllColumns === true ? _vm.allColumnsHeader : _vm.emp,
      "items": _vm.empList,
      "title": "Employee List",
      "landscape": true,
      "fontsize": _vm.showAllColumns === true ? 6 : 9,
      "cellpadding": _vm.showAllColumns === true ? 0.25 : 1
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? (_vm.showAllColumns === true ? _vm.allColumnsHeader : _vm.emp) : _vm.empSm,
      "items": _vm.empList,
      "hide-default-footer": "",
      "disable-pagination": "",
      "sort-by": ['emp_name', 'vendor_emp_id'],
      "multi-sort": "",
      "mobile-breakpoint": 0
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareEditEmp(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.emp_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.vendor_emp_id))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.emp_phone || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.emp_desig || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.act_proj_list || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.comp_proj_list || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.emp_email || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.emp_adr || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.city || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.pincode || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.emergency_contact || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.emergency_phone || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.blood_group || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.known_health_issue || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.date_of_birth) || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.date_of_joining)))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.years_exp || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.gender || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.aadhar_no || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.marital_status || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.official_number || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_id_verified ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_address_verified ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_police_verif_done ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_pf_opted ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.pf_no || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.uan || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_esi_opted ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.esi_no || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_gmc_opted ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.gmc_no || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_gpa_opted ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.gpa_no || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.is_sub_vendor_emp ? 'Yes' : 'No'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.pan || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.bank_acc_no || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.bank_ifsc_code || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.bank_name || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.bank_branch_name || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.payroll_cat || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.date_of_relieved ? _vm.handy.formatDate(props.item.date_of_relieved) : '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.status_reason || '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(props.item.last_working_date ? _vm.handy.formatDate(props.item.last_working_date) : '-'))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && _vm.showAllColumns === true) ? _c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.last_updated_on) || '-'))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.emp_status))])])]
      }
    }], null, false, 1685531695)
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view' && _vm.isAdmin === true) ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:20px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    style: ('position:fixed; top:55px; right:10px;'),
    attrs: {
      "dark": "",
      "fab": "",
      "small": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareEmpTimeline($event)
      }
    }
  }, [_c('v-icon', [_vm._v("format_list_bulleted_add")])], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "full-height": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "eForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveEmployee(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.handy.startWithUpper(_vm.lAction) + ' Employee') + "\n          ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.isDupEmp) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "color": "warning",
      "value": true
    }
  }, [_vm._v("\n                  Employee with similar details found in records. Please choose override and save again if it is not duplicate. "), _c('br'), _vm._v(" "), _c('v-data-table', {
    staticClass: "mt-2",
    attrs: {
      "headers": _vm.dupEmp,
      "items": _vm.dupEmpList,
      "hide-default-footer": "",
      "disable-pagination": "",
      "mobile-breakpoint": 0,
      "dark": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.emp_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.vendor_emp_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.aadhar_no || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.act_proj_list || '-'))])])]
      }
    }], null, false, 3568783435)
  }), _vm._v(" "), _c('div', {
    attrs: {
      "text-center": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Override",
      "hide-details": ""
    },
    model: {
      value: (_vm.dupOverride),
      callback: function($$v) {
        _vm.dupOverride = $$v
      },
      expression: "dupOverride"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "hide-details": "",
      "mandatory": false,
      "row": ""
    },
    model: {
      value: (_vm.empType),
      callback: function($$v) {
        _vm.empType = $$v
      },
      expression: "empType"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Own Employee",
      "value": "oe"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "outline": "",
      "color": _vm.lAction === 'create' ? 'success' : 'warning',
      "value": true
    }
  }, [_c('v-layout', {
    attrs: {
      "pa-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_vm._v("\n                Employee Id " + _vm._s(_vm.lAction === 'create' ? 'will be' : 'is') + "\n              ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [(!_vm.nextEmpEdited) ? _c('strong', [_vm._v(_vm._s(_vm.lAction === 'create' ? _vm.lEmp.next_vendor_emp_id : _vm.lEmp.vendor_emp_id))]) : _vm._e(), _vm._v(" "), (_vm.nextEmpEdited && _vm.lAction === 'create') ? _c('v-text-field', {
    attrs: {
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "10",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.lEmp.next_vendor_emp_id),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "next_vendor_emp_id", $$v)
      },
      expression: "lEmp.next_vendor_emp_id"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.nextEmpEdited && _vm.lAction === 'update') ? _c('v-text-field', {
    attrs: {
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "10",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.lEmp.vendor_emp_id),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "vendor_emp_id", $$v)
      },
      expression: "lEmp.vendor_emp_id"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.nextEmpEdited = !_vm.nextEmpEdited
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Employee Name [As Per Aadhar]",
      "rules": [_vm.rules.required],
      "maxlength": "50"
    },
    model: {
      value: (_vm.lEmp.emp_name),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "emp_name", $$v)
      },
      expression: "lEmp.emp_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Gender",
      "items": ['Male', 'Female'],
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lEmp.gender),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "gender", $$v)
      },
      expression: "lEmp.gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Designation",
      "items": _vm.empDesig,
      "item-text": "emp_desig",
      "item-value": "emp_desig_id",
      "rules": [_vm.rules.required],
      "return-object": ""
    },
    model: {
      value: (_vm.lEmp.emp_desig_pair),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "emp_desig_pair", $$v)
      },
      expression: "lEmp.emp_desig_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Staff Role",
      "items": _vm.empRole,
      "item-text": "staff_role",
      "item-value": "staff_role_id",
      "rules": [_vm.rules.required],
      "return-object": ""
    },
    model: {
      value: (_vm.lEmp.staff_role_pair),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "staff_role_pair", $$v)
      },
      expression: "lEmp.staff_role_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgjoinDt",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lEmp.date_of_joining
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lEmp, "date_of_joining", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lEmp, "date_of_joining", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "slot": "activator",
            "label": "Date Of Joining",
            "append-icon": "mdi-calendar-today",
            "readonly": "",
            "clearable": "",
            "rules": [_vm.rules.required]
          },
          slot: "activator",
          model: {
            value: (_vm.lEmp.date_of_joining),
            callback: function($$v) {
              _vm.$set(_vm.lEmp, "date_of_joining", $$v)
            },
            expression: "lEmp.date_of_joining"
          }
        }, on))]
      }
    }], null, false, 1045578302),
    model: {
      value: (_vm.dlgjoinDt),
      callback: function($$v) {
        _vm.dlgjoinDt = $$v
      },
      expression: "dlgjoinDt"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    model: {
      value: (_vm.lEmp.date_of_joining),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "date_of_joining", $$v)
      },
      expression: "lEmp.date_of_joining"
    }
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgjoinDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgjoinDt.save(_vm.lEmp.date_of_joining)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "AADHAR No.",
      "rules": [_vm.rules.required],
      "required": "",
      "minlength": "12",
      "maxlength": "12"
    },
    model: {
      value: (_vm.lEmp.aadhar_no),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "aadhar_no", $$v)
      },
      expression: "lEmp.aadhar_no"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgDt",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lEmp.date_of_birth
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lEmp, "date_of_birth", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lEmp, "date_of_birth", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "slot": "activator",
            "label": "Date Of Birth [As Per Aadhar]",
            "append-icon": "mdi-calendar-today",
            "readonly": "",
            "clearable": "",
            "rules": [_vm.rules.required]
          },
          slot: "activator",
          model: {
            value: (_vm.lEmp.date_of_birth),
            callback: function($$v) {
              _vm.$set(_vm.lEmp, "date_of_birth", $$v)
            },
            expression: "lEmp.date_of_birth"
          }
        }, on))]
      }
    }], null, false, 3917478194),
    model: {
      value: (_vm.dlgDt),
      callback: function($$v) {
        _vm.dlgDt = $$v
      },
      expression: "dlgDt"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "change": function($event) {
        return _vm.calculateAge(_vm.lEmp.date_of_birth)
      }
    },
    model: {
      value: (_vm.lEmp.date_of_birth),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "date_of_birth", $$v)
      },
      expression: "lEmp.date_of_birth"
    }
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgDt.save(_vm.lEmp.date_of_birth)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Age",
      "readonly": ""
    },
    model: {
      value: (_vm.lEmp.years_exp),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "years_exp", $$v)
      },
      expression: "lEmp.years_exp"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Marital Status",
      "items": ['Single', 'Married', 'Widowed', 'Separated', 'Divorced'],
      "required": "",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lEmp.marital_status),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "marital_status", $$v)
      },
      expression: "lEmp.marital_status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Official Number",
      "hide-details": "",
      "type": "number"
    },
    model: {
      value: (_vm.lEmp.official_number),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "official_number", $$v)
      },
      expression: "lEmp.official_number"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 ma-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_c('v-layout', [_c('v-card-title', [_vm._v("\n        Personal Information\n      ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Address",
      "rules": [_vm.rules.required],
      "maxlength": "100"
    },
    model: {
      value: (_vm.lEmp.emp_adr),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "emp_adr", $$v)
      },
      expression: "lEmp.emp_adr"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "City",
      "rules": [_vm.rules.required],
      "maxlength": "25"
    },
    model: {
      value: (_vm.lEmp.city),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "city", $$v)
      },
      expression: "lEmp.city"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "PIN Code",
      "rules": [_vm.rules.required],
      "maxlength": "10",
      "type": "number"
    },
    model: {
      value: (_vm.lEmp.pin_code),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "pin_code", $$v)
      },
      expression: "lEmp.pin_code"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Phone",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.lEmp.emp_phone),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "emp_phone", $$v)
      },
      expression: "lEmp.emp_phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Email",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lEmp.emp_email),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "emp_email", $$v)
      },
      expression: "lEmp.emp_email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Emergency Contact")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Phone",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.lEmp.emergency_phone),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "emergency_phone", $$v)
      },
      expression: "lEmp.emergency_phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Contact Person",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lEmp.emergency_contact),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "emergency_contact", $$v)
      },
      expression: "lEmp.emergency_contact"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Blood Group",
      "hide-details": "",
      "maxlength": "5"
    },
    model: {
      value: (_vm.lEmp.blood_group),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "blood_group", $$v)
      },
      expression: "lEmp.blood_group"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Health Issue Known",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lEmp.known_health_issue),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "known_health_issue", $$v)
      },
      expression: "lEmp.known_health_issue"
    }
  })], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 ma-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_c('v-layout', [_c('v-card-title', [_vm._v("\n        Payroll Information\n      ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Bank Account Details")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bank Account Number",
      "rules": [_vm.rules.required],
      "maxlength": "25"
    },
    model: {
      value: (_vm.lEmp.bank_acc_no),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "bank_acc_no", $$v)
      },
      expression: "lEmp.bank_acc_no"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bank IFSC Code",
      "rules": [_vm.rules.required],
      "maxlength": "15"
    },
    model: {
      value: (_vm.lEmp.bank_ifsc_code),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "bank_ifsc_code", $$v)
      },
      expression: "lEmp.bank_ifsc_code"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Bank Name",
      "rules": [_vm.rules.required],
      "maxlength": "40"
    },
    model: {
      value: (_vm.lEmp.bank_name),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "bank_name", $$v)
      },
      expression: "lEmp.bank_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Branch Name",
      "rules": [_vm.rules.required],
      "maxlength": "100"
    },
    model: {
      value: (_vm.lEmp.bank_branch_name),
      callback: function($$v) {
        _vm.$set(_vm.lEmp, "bank_branch_name", $$v)
      },
      expression: "lEmp.bank_branch_name"
    }
  })], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "title font-weight:bold"
        }, [_vm._v("Documents")])]
      },
      proxy: true
    }], null, false, 1035742485)
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('div', {
    staticClass: "my-notice"
  }, [_vm._v("\n              Must upload Aadhar card and Bank Passbook\n            ")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.empHeader,
      "items": _vm.lEmpDetails,
      "hide-default-footer": "",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.emp_doc_type))]), _vm._v(" "), _c('td', {
          class: props.item.files.length > 0 ? 'pt-2' : ''
        }, _vm._l((props.item.files), function(file, i) {
          return _c('span', {
            key: i
          }, [(file.is_selected) ? _c('span', [_c('v-chip', {
            staticClass: "mb-2",
            attrs: {
              "small": "",
              "close": ""
            },
            model: {
              value: (file.is_selected),
              callback: function($$v) {
                _vm.$set(file, "is_selected", $$v)
              },
              expression: "file.is_selected"
            }
          }, [_vm._v("\n                        " + _vm._s(file.file_name) + "\n                        "), _c('a', {
            staticStyle: {
              "text-decoration": "none"
            },
            attrs: {
              "href": _vm.handy.loadImg(file.file_url),
              "download": ""
            }
          }, [_c('v-btn', {
            staticClass: "mr-0 grey lighten-2 black--text text--lighten-4 ml-2",
            attrs: {
              "small": "",
              "icon": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "size": "25px"
            }
          }, [_vm._v("download")])], 1)], 1)]), _c('br')], 1) : _vm._e()])
        }), 0), _vm._v(" "), _c('td', {
          staticClass: "pl-2 pr-0"
        }, [_c('input', {
          ref: "fileInput",
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "type": "file",
            "accept": ".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg",
            "multiple": ""
          },
          on: {
            "change": function($event) {
              return _vm.loadFilesFromFileBrowser()
            }
          }
        }), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.pickFile(props.item.emp_doc_type_id)
            }
          }
        }, [_c('v-icon', [_vm._v("upload")])], 1)], 1)])]
      }
    }], null, false, 2770496048)
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [(_vm.lAction === 'update') ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.deleteEmp(_vm.lEmp)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'create') ? _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": !_vm.isFileAdded
    },
    on: {
      "click": function($event) {
        return _vm.deployeIntoProject()
      }
    }
  }, [_vm._v("Deploy")]) : _vm._e(), _vm._v(" "), (_vm.lAction !== 'create') ? _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("save")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "300",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showInsertUpdateDocType),
      callback: function($$v) {
        _vm.showInsertUpdateDocType = $$v
      },
      expression: "showInsertUpdateDocType"
    }
  }, [_c('v-flex', [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveDocTypeChange('doctype')
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("\n          " + _vm._s(_vm.handy.startWithUpper(_vm.lDAction)) + " Document Type\n        ")]), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Doc Type",
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.lDocType.emp_doc_type),
      callback: function($$v) {
        _vm.$set(_vm.lDocType, "emp_doc_type", $$v)
      },
      expression: "lDocType.emp_doc_type"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [(_vm.lDocType.emp_doc_type_id) ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.saveDocTypeChange('delete-doctype')
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showInsertUpdateDocType = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.lAction === 'upload') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pa-0 pl-3"
  }, [_vm._v("\n          Upload Employee List\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 text-center primary--text title font-italic"
  }, [_vm._v("\n          In just 4 steps\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "info info--text mr-2",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v("Step 1")]), _vm._v(" "), _c('span', [_vm._v("Download template")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('form', {
    attrs: {
      "method": "get",
      "action": "/files/Smartility_Backbone_Employee_Bulk_Upload_Template.xlsx"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0",
    attrs: {
      "type": "submit",
      "small": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-download")])], 1)], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "info info--text mr-2",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v("Step 2")]), _vm._v(" "), _c('span', [_vm._v("Fill-in details as guided in template")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "info info--text mr-2",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v("Step 3")]), _vm._v(" "), _c('span', [_vm._v("Save as CSV "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(Comma delimited)")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "caption grey--text pl-4 ml-4"
  }, [_c('span', {
    staticClass: "ml-4"
  }, [_vm._v("Go with OK/Yes when prompted while saving")])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "info info--text mr-2",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v("Step 4")]), _vm._v(" "), _c('span', [_vm._v("Upload the CSV file")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0 accent",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.promptUpload($event)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-upload")])], 1)], 1), _vm._v(" "), _c('input', {
    ref: "ipFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": function($event) {
        return _vm.validateFile()
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "mt-3 text-center primary--text title font-italic"
  }, [_vm._v("\n              Smartility BackBone takes care of rest\n            ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "info info--text mr-2",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v("Step 4")]), _vm._v(" "), _c('span', [_vm._v("Validate your information")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "info info--text mr-2",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v("Step 5")]), _vm._v(" "), _c('span', [_vm._v("Create Asset List")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0 pr-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'validate') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n          Bulk Upload\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-center pl-2 pr-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "mx-auto": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "info--text mb-2",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.validateInProgress) ? _c('span', [_vm._v("Loading and validating the file...")]) : _vm._e(), _vm._v(" "), (_vm.validFile && !_vm.validateInProgress) ? _c('span', [_vm._v("File validation is successfull "), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("mdi-check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile) ? _c('span', [_vm._v("File validation is failed "), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("mdi-close")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile && _vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("Invalid column headers, please ensure names and count are matching as per the template")]) : _vm._e(), _vm._v(" "), (!_vm.validFile && !_vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more invalid records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e(), _vm._v(" "), (!_vm.totFail && !_vm.loadInProgress) ? _c('span', [_vm._v("Tasks uploaded successfully"), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("mdi-check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Tasks upload failed"), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("mdi-close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Tasks upload partially failed"), _c('v-icon', {
    staticClass: "warning--text"
  }, [_vm._v("mdi-close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totFail && !_vm.loadInProgress) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more failed records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e()]), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "info",
      "value": _vm.readyForLoad ? 100 : (_vm.recsLoaded.length / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.readyForLoad ? _vm.totValid : _vm.recsLoaded.length) + "\n                ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Records")])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "success",
      "value": (_vm.totValid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                " + _vm._s(_vm.readyForLoad ? _vm.totLoaded : _vm.totValid) + "\n              ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Loaded' : 'Valid'))])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "error",
      "value": (_vm.totInvalid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n              " + _vm._s(_vm.readyForLoad ? _vm.totFail : _vm.totInvalid) + "\n            ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Failed' : 'Invalid'))])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lAction = 'upload'
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.totValid > 0) ? _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": "",
      "disabled": _vm.beingSaved
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uploadEmployee($event)
      }
    }
  }, [_vm._v("Process the valid records")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "mt-2 pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-3 text-left",
    attrs: {
      "headers": _vm.loadHeadSm,
      "items": _vm.recsLoaded,
      "hide-default-footer": "",
      "mobile-breakpoint": 0
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: (props.item.error ? (props.item.load_status === 'Failed' ? 'error' : 'error--text') : (props.item.load_status === 'Loaded' ? 'success' : '')),
          on: {
            "click": function($event) {
              props.item.error ? _vm.showError(props.item.error) : ''
            }
          }
        }, [_c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.vendor_emp_id))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.emp_name))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.pf_no))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.uan))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.esi_no))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.gmc_no))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.gpa_no))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.bank_acc_no))]), _vm._v(" "), _c('td', {
          staticClass: "pa-2"
        }, [_vm._v(_vm._s(props.item.bank_ifsc_code))])])]
      }
    }], null, false, 2309268554)
  })], 1)], 1)], 1), _vm._v(" "), (false) ? _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.showTimeline),
      callback: function($$v) {
        _vm.showTimeline = $$v
      },
      expression: "showTimeline"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-1 title primary--text"
  }, [_c('div', [_vm._v("Timeline")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showTimeline = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pl-0 pr-4 py-3",
    staticStyle: {
      "background-color": "#ffe8d9"
    }
  }, [_c('v-timeline', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.lEmpTimeline), function(timeline, n) {
    return _c('v-timeline-item', {
      key: n,
      class: n === _vm.lEmpTimeline.length - 1 ? 'pb-0' : '',
      attrs: {
        "small": "",
        "id": 'timeline_' + n
      }
    }, [_c('v-card', {
      staticClass: "primary--text"
    }, [_c('v-card-text', {
      staticClass: "pb-0 black--text"
    }, [(timeline.notes !== '') ? _c('div', _vm._l((timeline.timeLineNote), function(note, i) {
      return _c('div', {
        key: i
      }, [(note) ? _c('span', [_vm._v(_vm._s(i + 1 + '. ' + note))]) : _vm._e()])
    }), 0) : _c('div', {
      staticClass: "pb-1"
    }, [_vm._v("\n              " + _vm._s(timeline.notes) + "\n            ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
      staticClass: "caption pa-2"
    }, [_vm._v("\n            Updated by:  "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(timeline.action_by + ' On ' + _vm.handy.formatDate(timeline.action_dt) + ' ' + _vm.handy.getTime12Hrs(timeline.action_dt)))])])], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.15d4c8a886f5241c1a8d.js